import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './ListeEtudiants.css';
import '../styles/partner-styles.css';
import Sidebar from '../components/sidberadmin';
import * as XLSX from 'xlsx';
import {
  User, CheckCircle, XCircle, Award, Shield, Clock, Plus,
  Phone, Eye, Edit, BookOpen, Calendar, Cake, RotateCcw, X,
  Trash2, UserCheck, IdCard, MapPin, GraduationCap, CreditCard, FileText,
  UserX, AlertTriangle, FileSpreadsheet
} from "lucide-react";
import ModalEtudiantsInactifs from '../components/ModalEtudiantsInactifs';

// Importer le composant DesistementModal
import DesistementModalAdmin from '../components/DesistementModalAdmin';
import {
  STRUCTURE_FORMATION,
  FILIERE_BY_MODE,
  PAYS_LIST,
  LIEUX_FORMATION,
  SOURCES_INSCRIPTION,
  normalize,
  buildCoursCandidates,
  autoAssignCours,
  getFilieresParMode,
  getSpecialitesDisponibles,
  getOptionsDisponibles,
  getSpecialites2Disponibles,
  getOptions2Disponibles,
  getCoursFiltre,
  handleFormationChange,
  validerAnneeScolaire,
  validerFormationComplete,
  genererAnneeScolaireActuelle,
  genererCodeEtudiantMisAJour,
  formatDate,
  calculerAge,
  getNomComplet,
  getNomCommercial,
  getNomPartner,
  getInitialFormState,
  isTypeFormationIngenieur,
  getCycleParNiveau,
  getSpecialitesIngenieur,
  getOptionsIngenieur,
  isManualFiliere,
  getNiveauxDisponibles,
  calculateStudentPrice,
  REMISES_LIST
} from '../components/formationUtils';
// ✅ AJOUTER CET IMPORT après la ligne 50 environ
import DiplomeSelectors, {
  baccalaureatMarocain,
  baccalaureatEtranger,
  diplomesAcces,
  lieuxObtentionMaroc
} from '../components/DiplomeSelectors';
// Composant FormationSelector adapté au nouveau modèle backend
const FormationSelector = ({ form, onChange, prefix = '' }) => {
  const formationData = form.filiere ? STRUCTURE_FORMATION[form.filiere] : null;
  const isIngenieur = form.filiere === 'CYCLE_INGENIEUR';
  const hasNiveauFixe = formationData && !formationData.niveauxManuels;
  const allowedFilieres = getFilieresParMode(form.niveauFormation || '');

  // Pour les formations avec niveau auto-assigné, afficher le niveau fixe
  const niveauAffiche = hasNiveauFixe ? formationData.niveauFixe : form.niveau;

  useEffect(() => {
    if (hasNiveauFixe && formationData?.niveauFixe) {
      const attendu = String(formationData.niveauFixe);
      if (String(form.niveau) !== attendu) {
        onChange('niveau', attendu);
      }
    }
  }, [hasNiveauFixe, formationData, form.niveau]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (isIngenieur && form.niveau) {
      const attendu = getCycleParNiveau(form.niveau);
      if (form.cycle !== attendu) {
        onChange('cycle', attendu);
      }
    }
  }, [isIngenieur, form.niveau, form.cycle]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="formation-selector">
      <div className="form-row">
        <div className="form-group">
          <label>Filière *</label>
          <select
            name="filiere"
            value={form.filiere}
            onChange={(e) => onChange('filiere', e.target.value)}
            required
            disabled={!form.niveauFormation} // ما نسمحش بالاختيار قبل ما يختار المود
          >
            {!form.niveauFormation ? (
              <option value="">Choisissez d'abord FI / TA / Executive / VAE</option>
            ) : (
              <>
                <option value="">Sélectionner le type de formation...</option>
                {allowedFilieres.map((key) => (
                  <option key={key} value={key}>
                    {STRUCTURE_FORMATION[key]?.nom || key}
                  </option>
                ))}
              </>
            )}
          </select>
          {!form.niveauFormation && (
            <small style={{ color: '#666' }}>Veuillez choisir le mode (FI / TA / Executive / VAE) d'abord</small>
          )}
        </div>


        {/* Niveau - manuel pour certaines formations, auto-assigné pour d'autres */}
        {/* Niveau - manuel pour certaines formations, auto-assigné pour d'autres */}
        <div className="form-group">
          <label>
            {form.filiere === 'MASTER_PRO' ? 'Année Master *' : 'Niveau'}
            {hasNiveauFixe && (
              <span className="auto-assigned"> (Auto-assigné)</span>
            )}
          </label>
          {hasNiveauFixe ? (
            <input
              type="text"
              value={`Niveau ${niveauAffiche}`}
              disabled
              style={{ backgroundColor: '#f0f0f0', color: '#666' }}
            />
          ) : (
            <select
              name="niveau"
              value={form.niveau || ''}
              onChange={(e) => onChange('niveau', e.target.value)}
              required={form.filiere && !hasNiveauFixe}
            >
              <option value="">
                {form.filiere === 'MASTER_PRO' ? 'Choisir M1 ou M2...' : 'Sélectionner le niveau...'}
              </option>
              {getNiveauxDisponibles(form.filiere).map((n) => (
                <option key={n} value={String(n)}>
                  {form.filiere === 'MASTER_PRO'
                    ? n === 4 ? 'Master 1 (M1)' : 'Master 2 (M2)'
                    : n === 1 ? '1ère année' : `${n}ème année`}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>

      {/* Cycle pour École d'Ingénieur */}
      {isIngenieur && form.niveau && (
        <div className="form-group">
          <label>Cycle *</label>
          <input
            type="text"
            value={form.cycle || getCycleParNiveau(form.niveau)}
            disabled
            style={{ backgroundColor: '#f0f0f0', color: '#666' }}
          />
          <small style={{ color: '#666', fontSize: '12px' }}>
            Le cycle est déterminé automatiquement selon le niveau
          </small>
        </div>
      )}

      {/* Spécialité d'Ingénieur */}
      {isIngenieur && form.niveau >= 3 && (
        <div className="form-group">
          <label>Spécialité d'Ingénieur *</label>
          <select
            name="specialiteIngenieur"
            value={form.specialiteIngenieur || ''}
            onChange={(e) => onChange('specialiteIngenieur', e.target.value)}
            required
          >
            <option value="">Sélectionner la spécialité...</option>
            {formationData.cycles['Cycle Ingénieur'].specialites.map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {/* Option d'Ingénieur */}
      {isIngenieur && Number(form.niveau) === 5 && form.specialiteIngenieur && (
        <div className="form-group">
          <label>Option d'Ingénieur *</label>
          <select
            name="optionIngenieur"
            value={form.optionIngenieur || ''}
            onChange={(e) => onChange('optionIngenieur', e.target.value)}
            required
          >
            <option value="">Sélectionner l'option...</option>
            {formationData.cycles['Cycle Ingénieur'].options[form.specialiteIngenieur]?.map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Spécialité Licence Pro */}
      {form.filiere === 'LICENCE_PRO' && (
        <div className="form-group">
          <label>Spécialité Licence Pro *</label>
          <select
            name="specialiteLicencePro"
            value={form.specialiteLicencePro || ''}
            onChange={(e) => onChange('specialiteLicencePro', e.target.value)}
            required
          >
            <option value="">Sélectionner une spécialité...</option>
            {formationData.specialites.map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {/* Option Licence Pro */}
      {form.filiere === 'LICENCE_PRO' && form.specialiteLicencePro && formationData.options[form.specialiteLicencePro] && (
        <div className="form-group">
          <label>Option Licence Pro</label>
          <select
            name="optionLicencePro"
            value={form.optionLicencePro || ''}
            onChange={(e) => onChange('optionLicencePro', e.target.value)}
          >
            <option value="">Sélectionner une option...</option>
            {formationData.options[form.specialiteLicencePro].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Spécialité Master Pro */}
      {form.filiere === 'MASTER_PRO' && (
        <div className="form-group">
          <label>Spécialité Master Pro *</label>
          <select
            name="specialiteMasterPro"
            value={form.specialiteMasterPro || ''}
            onChange={(e) => onChange('specialiteMasterPro', e.target.value)}
            required
          >
            <option value="">Sélectionner une spécialité...</option>
            {formationData.specialites.map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {/* Option Master Pro */}
      {form.filiere === 'MASTER_PRO' && form.specialiteMasterPro && formationData.options[form.specialiteMasterPro] && (
        <div className="form-group">
          <label>Option Master Pro</label>
          <select
            name="optionMasterPro"
            value={form.optionMasterPro || ''}
            onChange={(e) => onChange('optionMasterPro', e.target.value)}
          >
            <option value="">Sélectionner une option...</option>
            {formationData.options[form.specialiteMasterPro].map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Spécialité pour MASI/IRM/GENIE_CIVIL/MECATRONIQUE */}
      {isManualFiliere(form.filiere) && Number(form.niveau) >= 3 && (
        <div className="form-group">
          <label>Spécialité *</label>
          <select
            name="specialite"
            value={form.specialite || ''}
            onChange={(e) => onChange('specialite', e.target.value)}
            required
          >
            <option value="">Sélectionner la spécialité...</option>
            {getSpecialitesDisponibles(form.filiere, form.niveau).map((spec) => (
              <option key={spec} value={spec}>{spec}</option>
            ))}
          </select>
        </div>
      )}

      {isManualFiliere(form.filiere) && parseInt(form.niveau) === 5 && form.specialite && getOptionsDisponibles(form.filiere, form.niveau, form.specialite).length > 0 && (

        <div className="form-group">
          <label>Option *</label>
          <select
            name="option"
            value={form.option || ''}
            onChange={(e) => onChange('option', e.target.value)}
            required
          >
            <option value="">Sélectionner l'option...</option>
            {getOptionsDisponibles(form.filiere, form.niveau, form.specialite).map((opt) => (
              <option key={opt} value={opt}>{opt}</option>
            ))}
          </select>
        </div>
      )}

      {/* Indicateur de parcours */}
      {form.filiere && (
        <div className="parcours-indicator">
          <h5>Parcours sélectionné :</h5>
          <div className="parcours-path">
            <span className="parcours-item filiere">
              {formationData?.nom || form.filiere}
            </span>
            {niveauAffiche && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item niveau">
                  Niveau {niveauAffiche}
                  {hasNiveauFixe && <small> (auto)</small>}
                </span>
              </>
            )}
            {form.cycle && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item cycle">{form.cycle}</span>
              </>
            )}
            {(form.specialiteIngenieur || form.specialiteLicencePro || form.specialiteMasterPro || form.specialite) && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item specialite">
                  {form.specialiteIngenieur || form.specialiteLicencePro || form.specialiteMasterPro || form.specialite}
                </span>
              </>
            )}
            {(form.optionIngenieur || form.optionLicencePro || form.optionMasterPro || form.option) && (
              <>
                <span className="parcours-arrow">→</span>
                <span className="parcours-item option">
                  {form.optionIngenieur || form.optionLicencePro || form.optionMasterPro || form.option}
                </span>
              </>
            )}
          </div>
        </div>
      )}

      {/* Double Compétence IT */}
      <div className="form-group" style={{ marginTop: '20px', padding: '12px 16px', backgroundColor: '#f8fafc', borderRadius: '8px', border: '1px solid #cbd5e1' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', fontWeight: 'bold', fontSize: '14px', color: '#1e293b', marginBottom: 0 }}>
          <input
            type="checkbox"
            name="doubleCompetenceIT"
            checked={!!form.doubleCompetenceIT}
            onChange={(e) => onChange('doubleCompetenceIT', e.target.checked)}
            style={{ width: '18px', height: '18px', cursor: 'pointer', accentColor: '#2563eb' }}
          />
          <span>Double Compétence IT</span>
        </label>

        {form.doubleCompetenceIT && (
          <div className="double-competence-block" style={{ marginTop: '14px', paddingTop: '14px', borderTop: '1px dashed #94a3b8' }}>
            <h5 style={{ marginBottom: '12px', color: '#0f172a', fontSize: '13px', fontWeight: '600', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
              Deuxième Formation (Double Compétence)
            </h5>
            <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px', marginBottom: '12px' }}>
              <div className="form-group">
                <label style={{ fontSize: '12px', fontWeight: '600' }}>Mode de formation 2</label>
                <select
                  name="niveauFormation2"
                  value={form.niveauFormation2 || ''}
                  onChange={(e) => onChange('niveauFormation2', e.target.value)}
                >
                  <option value="">Sélectionner le mode 2...</option>
                  <option value="FI">FI (Formation Initiale)</option>
                  <option value="TA">TA (Temps Alterné)</option>
                  <option value="Executive">Executive</option>
                  <option value="VAE">VAE</option>
                </select>
              </div>

              <div className="form-group">
                <label style={{ fontSize: '12px', fontWeight: '600' }}>Filière 2</label>
                <select
                  name="filiere2"
                  value={form.filiere2 || ''}
                  onChange={(e) => onChange('filiere2', e.target.value)}
                  disabled={!form.niveauFormation2}
                >
                  {!form.niveauFormation2 ? (
                    <option value="">Choisissez le mode 2 d'abord</option>
                  ) : (
                    <>
                      <option value="">Sélectionner la filière 2...</option>
                      {getFilieresParMode(form.niveauFormation2 || '').map((key) => (
                        <option key={key} value={key}>
                          {STRUCTURE_FORMATION[key]?.nom || key}
                        </option>
                      ))}
                    </>
                  )}
                </select>
              </div>
            </div>

            {form.filiere2 && (
              <div className="form-row" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div className="form-group">
                  <label style={{ fontSize: '12px', fontWeight: '600' }}>Spécialité 2</label>
                  {getSpecialites2Disponibles(form.filiere2).length > 0 ? (
                    <select
                      name="specialite2"
                      value={form.specialite2 || ''}
                      onChange={(e) => onChange('specialite2', e.target.value)}
                    >
                      <option value="">Sélectionner la spécialité 2...</option>
                      {getSpecialites2Disponibles(form.filiere2).map((spec) => (
                        <option key={spec} value={spec}>{spec}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      name="specialite2"
                      placeholder="Saisir la spécialité 2..."
                      value={form.specialite2 || ''}
                      onChange={(e) => onChange('specialite2', e.target.value)}
                    />
                  )}
                </div>

                <div className="form-group">
                  <label style={{ fontSize: '12px', fontWeight: '600' }}>Option 2</label>
                  {getOptions2Disponibles(form.filiere2, form.specialite2).length > 0 ? (
                    <select
                      name="option2"
                      value={form.option2 || ''}
                      onChange={(e) => onChange('option2', e.target.value)}
                    >
                      <option value="">Sélectionner l'option 2...</option>
                      {getOptions2Disponibles(form.filiere2, form.specialite2).map((opt) => (
                        <option key={opt} value={opt}>{opt}</option>
                      ))}
                    </select>
                  ) : (
                    <input
                      type="text"
                      name="option2"
                      placeholder="Saisir l'option 2..."
                      value={form.option2 || ''}
                      onChange={(e) => onChange('option2', e.target.value)}
                    />
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

const ListeEtudiants = () => {
  const [etudiants, setEtudiants] = useState([]);
  const [etudiantsFiltres, setEtudiantsFiltres] = useState([]);
  const [recherche, setRecherche] = useState('');
  const [filtreGenre, setFiltreGenre] = useState('');
  const [filtreCours, setFiltreCours] = useState('');
  const [filtreActif, setFiltreActif] = useState('');
  const [filtreCommercial, setFiltreCommercial] = useState('');
  const [filtreAnneeScolaire, setFiltreAnneeScolaire] = useState('');
  const [filtrePartner, setFiltrePartner] = useState('');
  const [pageActuelle, setPageActuelle] = useState(1);
  const [etudiantsParPage, setEtudiantsParPage] = useState(10);
  const [loading, setLoading] = useState(true);
  // États pour le modal de désistement
  const [showDesistementModal, setShowDesistementModal] = useState(false);
  const [etudiantDesistement, setEtudiantDesistement] = useState(null);
  // États pour l'export Excel
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportAnneeScolaire, setExportAnneeScolaire] = useState('');
  const [loadingExport, setLoadingExport] = useState(false);

  // États pour le verrouillage de l'auto-sélection des cours
  const [lockCoursAjout, setLockCoursAjout] = useState(false);
  const [lockCoursModifier, setLockCoursModifier] = useState(false);

  // États pour le modal d'ajout
  const [showModal, setShowModal] = useState(false);
  const [formAjout, setFormAjout] = useState(getInitialFormState());


  const [vueMode, setVueMode] = useState('tableau');
  const [imageFile, setImageFile] = useState(null);
  const [listeCours, setListeCours] = useState([]);
  const [listeCommerciaux, setListeCommerciaux] = useState([]);
  const [messageAjout, setMessageAjout] = useState('');
  const [loadingAjout, setLoadingAjout] = useState(false);

  // États pour le modal de visualisation
  const [showViewModal, setShowViewModal] = useState(false);
  const [etudiantSelectionne, setEtudiantSelectionne] = useState(null);

  // États pour le modal de modification
  const [showEditModal, setShowEditModal] = useState(false);

  const [formModifier, setFormModifier] = useState({
    prenom: '',
    nomDeFamille: '',
    genre: 'Homme',
    dateNaissance: '',
    anneeScolaire: genererAnneeScolaireActuelle(),
    telephone: '',
    email: '',
    motDePasse: '',
    cin: '',
    passeport: '',
    lieuNaissance: '',
    lieuFormation: '',
    pays: '',
    cours: [],
    niveau: '',
    niveauFormation: '',
    filiere: '',
    option: '',
    specialite: '',
    typeDiplome: '',
    diplomeAcces: '',
    specialiteDiplomeAcces: '',
    mention: '',
    lieuObtentionDiplome: '',
    serieBaccalaureat: '',
    anneeBaccalaureat: '',
    premiereAnneeInscription: '',
    sourceInscription: '',
    dateInscription: '',
    typePaiement: '',
    modePaiement: 'mensuel',
    prixTotal: '',
    pourcentageBourse: '',
    situation: '',
    codeEtudiant: '',
    dateEtReglement: '',
    actif: true,
    nouvelleInscription: true,
    paye: false,
    handicape: false,
    resident: false,
    fonctionnaire: false,
    mobilite: false,
    commercial: '',
    cycle: '',
    specialiteIngenieur: '',
    optionIngenieur: '',
    // Nouveaux champs pour le modèle backend
    specialiteLicencePro: '',
    optionLicencePro: '',
    specialiteMasterPro: '',
    optionMasterPro: '',
    // Nouveaux champs supplémentaires
    telephoneResponsable: '',
    codeBaccalaureat: '',
    codeMassar: '',
    // Nouveaux champs Partner
    isPartner: false,
    nomPartner: '',
    prixTotalPartner: ''
  });

  const [imageFileModifier, setImageFileModifier] = useState(null);
  const [messageModifier, setMessageModifier] = useState('');
  const [loadingModifier, setLoadingModifier] = useState(false);
  const [etudiantAModifier, setEtudiantAModifier] = useState(null);
  // Fonctions pour le modal de désistement
  const openDesistementModal = (etudiant) => {
    setEtudiantDesistement(etudiant);
    setShowDesistementModal(true);
  };

  const closeDesistementModal = () => {
    setShowDesistementModal(false);
    setEtudiantDesistement(null);
  };

  const handleDesistementSuccess = (etudiantMisAJour) => {
    setEtudiants(etudiants.map(e => e._id === etudiantMisAJour._id ? etudiantMisAJour : e));
  };
  // Nouveaux états pour les documents avec commentaires
  const [documentsAjout, setDocumentsAjout] = useState({
    documentCin: null,
    documentBacCommentaire: null,
    documentReleveNoteBac: null,
    documentDiplomeCommentaire: null,
    documentAttestationReussiteCommentaire: null,
    documentReleveNotesFormationCommentaire: null,
    documentPasseport: null,
    documentBacOuAttestationBacCommentaire: null,
    documentAuthentificationBac: null,
    documentAuthenticationDiplome: null,
    documentEngagementCommentaire: null
  });

  const [commentairesAjout, setCommentairesAjout] = useState({
    commentaireCin: '',
    commentaireBacCommentaire: '',
    commentaireReleveNoteBac: '',
    commentaireDiplomeCommentaire: '',
    commentaireAttestationReussiteCommentaire: '',
    commentaireReleveNotesFormationCommentaire: '',
    commentairePasseport: '',
    commentaireBacOuAttestationBacCommentaire: '',
    commentaireAuthentificationBac: '',
    commentaireAuthenticationDiplome: '',
    commentaireEngagementCommentaire: ''
  });

  const [documentsModifier, setDocumentsModifier] = useState({
    documentCin: null,
    documentBacCommentaire: null,
    documentReleveNoteBac: null,
    documentDiplomeCommentaire: null,
    documentAttestationReussiteCommentaire: null,
    documentReleveNotesFormationCommentaire: null,
    documentPasseport: null,
    documentBacOuAttestationBacCommentaire: null,
    documentAuthentificationBac: null,
    documentAuthenticationDiplome: null,
    documentEngagementCommentaire: null
  });
  const [showModalInactifs, setShowModalInactifs] = useState(false);

  const [commentairesModifier, setCommentairesModifier] = useState({
    commentaireCin: '',
    commentaireBacCommentaire: '',
    commentaireReleveNoteBac: '',
    commentaireDiplomeCommentaire: '',
    commentaireAttestationReussiteCommentaire: '',
    commentaireReleveNotesFormationCommentaire: '',
    commentairePasseport: '',
    commentaireBacOuAttestationBacCommentaire: '',
    commentaireAuthentificationBac: '',
    commentaireAuthenticationDiplome: '',
    commentaireEngagementCommentaire: ''
  });
  const openModalInactifs = () => {
    setShowModalInactifs(true);
  };

  // Fermer le modal des inactifs
  const closeModalInactifs = () => {
    setShowModalInactifs(false);
  };
  const handleAfterRestaure = () => {
    // Recharger la liste des étudiants actifs
    fetchEtudiants();
  };
  const coursFiltresModif = getCoursFiltre(listeCours, formModifier);
  const navigate = useNavigate();

  // Handlers pour la formation intelligente
  const handleFormationChangeAjout = handleFormationChange(setFormAjout, formAjout);
  const handleFormationChangeModifier = handleFormationChange(setFormModifier, formModifier);

  useEffect(() => {
    fetchEtudiants();
    fetchCours();
    fetchCommerciaux();
  }, []);

  useEffect(() => {
    filtrerEtudiants();
  }, [etudiants, recherche, filtreGenre, filtreCours, filtreActif, filtreCommercial, filtreAnneeScolaire, filtrePartner]); // eslint-disable-line react-hooks/exhaustive-deps


  // Auto-assign pour AJOUT
  useEffect(() => {
    autoAssignCours(formAjout, setFormAjout, listeCours, lockCoursAjout);
  }, [
    formAjout.niveauFormation,
    formAjout.filiere, formAjout.niveau,
    formAjout.specialite, formAjout.option,
    formAjout.cycle, formAjout.specialiteIngenieur, formAjout.optionIngenieur,
    formAjout.specialiteLicencePro, formAjout.optionLicencePro,
    formAjout.specialiteMasterPro, formAjout.optionMasterPro,
    listeCours, lockCoursAjout
  ]);

  // Auto-assign pour MODIFICATION
  useEffect(() => {
    autoAssignCours(formModifier, setFormModifier, listeCours, lockCoursModifier);
  }, [
    formModifier.niveauFormation,
    formModifier.filiere, formModifier.niveau,
    formModifier.specialite, formModifier.option,
    formModifier.cycle, formModifier.specialiteIngenieur, formModifier.optionIngenieur,
    formModifier.specialiteLicencePro, formModifier.optionLicencePro,
    formModifier.specialiteMasterPro, formModifier.optionMasterPro,
    listeCours, lockCoursModifier
  ]);

  // Génération automatique du code étudiant pour l'ajout
  useEffect(() => {
    if (formAjout.filiere && formAjout.prenom && formAjout.nomDeFamille) {
      const codeGenere = genererCodeEtudiantMisAJour(formAjout);
      if (codeGenere !== formAjout.codeEtudiant) {
        setFormAjout(prev => ({ ...prev, codeEtudiant: codeGenere }));
      }
    }
  }, [formAjout.filiere, formAjout.niveau, formAjout.prenom, formAjout.nomDeFamille, formAjout.specialiteIngenieur]);

  // Génération automatique du code étudiant pour la modification
  useEffect(() => {
    if (formModifier.filiere && formModifier.prenom && formModifier.nomDeFamille) {
      const codeGenere = genererCodeEtudiantMisAJour(formModifier);
      if (!formModifier.codeEtudiant) {
        setFormModifier(prev => ({ ...prev, codeEtudiant: codeGenere }));
      }
    }
  }, [formModifier.filiere, formModifier.niveau, formModifier.prenom, formModifier.nomDeFamille, formModifier.specialiteIngenieur]);

  // Auto-calcul des tarifs et remises pour l'ajout (année 2026/2027)
  useEffect(() => {
    if (formAjout.anneeScolaire === '2026/2027' && !formAjout.isPartner) {
      const isCustom = formAjout.typeRemise === 'custom';
      const calculated = calculateStudentPrice(
        formAjout.filiere,
        formAjout.niveau,
        formAjout.typeRemise || 'none',
        isCustom ? formAjout.remiseMontant : 0
      );
      setFormAjout(prev => ({
        ...prev,
        fraisInscription: calculated.fraisInscription,
        fraisScolariteBase: calculated.fraisScolariteBase,
        remiseMontant: isCustom ? prev.remiseMontant : calculated.remiseMontant,
        prixTotal: calculated.prixTotal,
        pourcentageBourse: calculated.pourcentageBourse
      }));
    }
  }, [
    formAjout.anneeScolaire,
    formAjout.filiere,
    formAjout.niveau,
    formAjout.typeRemise,
    formAjout.isPartner,
    formAjout.typeRemise === 'custom' ? formAjout.remiseMontant : null
  ]);

  // Auto-calcul des tarifs et remises pour la modification (année 2026/2027)
  useEffect(() => {
    if (formModifier.anneeScolaire === '2026/2027' && !formModifier.isPartner) {
      const isCustom = formModifier.typeRemise === 'custom';
      const calculated = calculateStudentPrice(
        formModifier.filiere,
        formModifier.niveau,
        formModifier.typeRemise || 'none',
        isCustom ? formModifier.remiseMontant : 0
      );
      setFormModifier(prev => ({
        ...prev,
        fraisInscription: calculated.fraisInscription,
        fraisScolariteBase: calculated.fraisScolariteBase,
        remiseMontant: isCustom ? prev.remiseMontant : calculated.remiseMontant,
        prixTotal: calculated.prixTotal,
        pourcentageBourse: calculated.pourcentageBourse
      }));
    }
  }, [
    formModifier.anneeScolaire,
    formModifier.filiere,
    formModifier.niveau,
    formModifier.typeRemise,
    formModifier.isPartner,
    formModifier.typeRemise === 'custom' ? formModifier.remiseMontant : null
  ]);

  const fetchEtudiants = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const res = await axios.get('    https://vmi1977988.contaboserver.net/api2/etudiants', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setEtudiants(res.data);
    } catch (err) {
      console.error('Erreur:', err);
    } finally {
      setLoading(false);
    }
  };

  const fetchCours = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('    https://vmi1977988.contaboserver.net/api2/cours', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListeCours(res.data);
    } catch (err) {
      console.error('Erreur lors du chargement des cours:', err);
    }
  };

  const fetchCommerciaux = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('    https://vmi1977988.contaboserver.net/api2/commerciaux', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setListeCommerciaux(res.data);
    } catch (err) {
      console.error('Erreur lors du chargement des commerciaux:', err);
      setListeCommerciaux([]);
    }
  };

  const filtrerEtudiants = () => {
    let resultats = etudiants;

    // Filtre par recherche (prénom, nom de famille, téléphone, email)
    if (recherche) {
      resultats = resultats.filter(e => {
        const nomComplet = `${e.prenom || ''} ${e.nomDeFamille || ''}`.toLowerCase();
        return (
          nomComplet.includes(recherche.toLowerCase()) ||
          (e.telephone && e.telephone.includes(recherche)) ||
          (e.email && e.email.toLowerCase().includes(recherche.toLowerCase())) ||
          (e.cin && e.cin.toLowerCase().includes(recherche.toLowerCase())) ||
          (e.codeMassar && e.codeMassar.toLowerCase().includes(recherche.toLowerCase())) ||
          (e.codeEtudiant && e.codeEtudiant.toLowerCase().includes(recherche.toLowerCase()))
        );
      });
    }

    if (filtreGenre) {
      resultats = resultats.filter(e => e.genre === filtreGenre);
    }

    if (filtreCours) {
      resultats = resultats.filter(e =>
        e.cours && e.cours.some(cours => cours.toLowerCase().includes(filtreCours.toLowerCase()))
      );
    }

    if (filtreActif !== '') {
      resultats = resultats.filter(e => e.actif === (filtreActif === 'true'));
    }

    if (filtreCommercial) {
      resultats = resultats.filter(e => e.commercial === filtreCommercial);
    }

    // ✅ بعد
    if (filtreAnneeScolaire) {
      resultats = resultats.filter(e => e.anneeScolaire === filtreAnneeScolaire);
    }

    if (filtrePartner !== '') {
      resultats = resultats.filter(e => e.isPartner === (filtrePartner === 'true'));
    }

    setEtudiantsFiltres(resultats);
    setPageActuelle(1);
  };

  // Fonctions pour le modal d'ajout
  const openModal = () => {
    setShowModal(true);
    setMessageAjout('');
    setLockCoursAjout(false);
  };

  const closeModal = () => {
    setShowModal(false);
    setFormAjout({
      prenom: '',
      nomDeFamille: '',
      genre: 'Homme',
      dateNaissance: '',
      telephone: '',
      email: '',
      motDePasse: '',
      cin: '',
      passeport: '',
      anneeScolaire: genererAnneeScolaireActuelle(),
      lieuNaissance: '',
      lieuFormation: '',
      pays: '',
      cours: [],
      niveau: '',
      niveauFormation: '',
      filiere: '',
      option: '',
      specialite: '',
      typeDiplome: '',
      diplomeAcces: '',
      specialiteDiplomeAcces: '',
      mention: '',
      lieuObtentionDiplome: '',
      serieBaccalaureat: '',
      anneeBaccalaureat: '',
      premiereAnneeInscription: '',
      sourceInscription: '',
      dateInscription: '',
      typePaiement: '',
      modePaiement: 'mensuel',
      prixTotal: '',
      pourcentageBourse: '',
      situation: '',
      codeEtudiant: '',
      dateEtReglement: '',
      actif: true,
      nouvelleInscription: true,
      paye: false,
      handicape: false,
      resident: false,
      fonctionnaire: false,
      mobilite: false,
      commercial: '',
      cycle: '',
      specialiteIngenieur: '',
      optionIngenieur: '',
      // Nouveaux champs pour le modèle backend
      specialiteLicencePro: '',
      optionLicencePro: '',
      specialiteMasterPro: '',
      optionMasterPro: '',
      // Nouveaux champs supplémentaires
      telephoneResponsable: '',
      codeBaccalaureat: '',
      codeMassar: '',
      // Nouveaux champs Partner
      isPartner: false,
      nomPartner: '',
      prixTotalPartner: ''
    });
    setDocumentsAjout({
      documentCin: null,
      documentBacCommentaire: null,
      documentReleveNoteBac: null,
      documentDiplomeCommentaire: null,
      documentAttestationReussiteCommentaire: null,
      documentReleveNotesFormationCommentaire: null,
      documentPasseport: null,
      documentBacOuAttestationBacCommentaire: null,
      documentAuthentificationBac: null,
      documentAuthenticationDiplome: null,
      documentEngagementCommentaire: null
    });
    setCommentairesAjout({
      commentaireCin: '',
      commentaireBacCommentaire: '',
      commentaireReleveNoteBac: '',
      commentaireDiplomeCommentaire: '',
      commentaireAttestationReussiteCommentaire: '',
      commentaireReleveNotesFormationCommentaire: '',
      commentairePasseport: '',
      commentaireBacOuAttestationBacCommentaire: '',
      commentaireAuthentificationBac: '',
      commentaireAuthenticationDiplome: '',
      commentaireEngagementCommentaire: ''
    });
    setImageFile(null);
    setMessageAjout('');
    setLockCoursAjout(false);
  };
  const coursFiltres = getCoursFiltre(listeCours, formAjout);

  // Fonctions pour le modal de modification
  const openEditModal = (etudiant) => {
    console.log('🔍 Données étudiant reçues:', etudiant); // Pour débugger

    const rawDateInscription = etudiant.dateInscription || etudiant.createdAt;
    const dateInscriptionFormatted = rawDateInscription
      ? (typeof rawDateInscription === 'string' ? rawDateInscription.slice(0, 10) : new Date(rawDateInscription).toISOString().slice(0, 10))
      : '';
    const dateNaissanceFormatted = etudiant.dateNaissance
      ? (typeof etudiant.dateNaissance === 'string' ? etudiant.dateNaissance.slice(0, 10) : new Date(etudiant.dateNaissance).toISOString().slice(0, 10))
      : '';

    setEtudiantAModifier(etudiant);
    setFormModifier({
      prenom: etudiant.prenom || '',
      nomDeFamille: etudiant.nomDeFamille || '',
      genre: etudiant.genre || 'Homme',
      dateNaissance: dateNaissanceFormatted,
      telephone: etudiant.telephone || '',
      email: etudiant.email || '',
      motDePasse: '', // Toujours vide pour modification
      cin: etudiant.cin || '',
      passeport: etudiant.passeport || '',
      lieuNaissance: etudiant.lieuNaissance || '',
      lieuFormation: etudiant.lieuFormation || '',
      pays: etudiant.pays || '',
      cours: etudiant.cours || [],
      niveau: etudiant.niveau != null ? String(etudiant.niveau) : '',
      niveauFormation: etudiant.niveauFormation || '',
      filiere: etudiant.filiere || '',
      option: etudiant.option || '',
      specialite: etudiant.specialite || '',
      typeDiplome: etudiant.typeDiplome || '',
      diplomeAcces: etudiant.diplomeAcces || '',
      specialiteDiplomeAcces: etudiant.specialiteDiplomeAcces || '',
      mention: etudiant.mention || '',
      anneeScolaire: etudiant.anneeScolaire || genererAnneeScolaireActuelle(),
      lieuObtentionDiplome: etudiant.lieuObtentionDiplome || '',
      serieBaccalaureat: etudiant.serieBaccalaureat || '',
      anneeBaccalaureat: etudiant.anneeBaccalaureat || '',
      premiereAnneeInscription: etudiant.premiereAnneeInscription || '',
      sourceInscription: etudiant.sourceInscription || '',
      dateInscription: dateInscriptionFormatted,
      typePaiement: etudiant.typePaiement || '',
      modePaiement: etudiant.modePaiement || 'mensuel',
      prixTotal: etudiant.prixTotal || '',
      pourcentageBourse: etudiant.pourcentageBourse || '',
      fraisInscription: etudiant.fraisInscription != null ? etudiant.fraisInscription : 3000,
      fraisScolariteBase: etudiant.fraisScolariteBase != null ? etudiant.fraisScolariteBase : 35000,
      typeRemise: etudiant.typeRemise || 'none',
      remiseMontant: etudiant.remiseMontant != null ? etudiant.remiseMontant : (etudiant.remise != null ? etudiant.remise : 0),
      situation: etudiant.situation || '',
      codeEtudiant: etudiant.codeEtudiant || '',
      dateEtReglement: etudiant.dateEtReglement || '',
      actif: etudiant.actif ?? true,
      nouvelleInscription: etudiant.nouvelleInscription ?? true,
      paye: etudiant.paye ?? false,
      handicape: etudiant.handicape ?? false,
      resident: etudiant.resident ?? false,
      fonctionnaire: etudiant.fonctionnaire ?? false,
      mobilite: etudiant.mobilite ?? false,
      commercial: etudiant.commercial?._id || etudiant.commercial || '',
      cycle: etudiant.cycle || (etudiant.filiere === 'CYCLE_INGENIEUR' && etudiant.niveau ? getCycleParNiveau(etudiant.niveau) : ''),
      specialiteIngenieur: etudiant.specialiteIngenieur || (etudiant.filiere === 'CYCLE_INGENIEUR' && ['Génie Informatique', 'Génie Mécatronique', 'Génie Civil'].includes(etudiant.specialite) ? etudiant.specialite : '') || '',
      optionIngenieur: etudiant.optionIngenieur || '',

      // 🔥 SOLUTION : Pré-remplir avec les données existantes
      specialiteLicencePro: etudiant.specialiteLicencePro || '',
      optionLicencePro: etudiant.optionLicencePro || '',
      specialiteMasterPro: etudiant.specialiteMasterPro || '',
      optionMasterPro: etudiant.optionMasterPro || '',
      // Nouveaux champs supplémentaires
      telephoneResponsable: etudiant.telephoneResponsable || '',
      codeBaccalaureat: etudiant.codeBaccalaureat || '',
      codeMassar: etudiant.codeMassar || '',
      // Nouveaux champs Partner
      isPartner: etudiant.isPartner || false,
      nomPartner: etudiant.nomPartner || '',
      prixTotalPartner: etudiant.prixTotalPartner || ''
    });

    // Pré-remplir les commentaires des documents
    setCommentairesModifier({
      commentaireCin: etudiant.documents?.cin?.commentaire || '',
      commentaireBacCommentaire: etudiant.documents?.bacCommentaire?.commentaire || '',
      commentaireReleveNoteBac: etudiant.documents?.releveNoteBac?.commentaire || '',
      commentaireDiplomeCommentaire: etudiant.documents?.diplomeCommentaire?.commentaire || '',
      commentaireAttestationReussiteCommentaire: etudiant.documents?.attestationReussiteCommentaire?.commentaire || '',
      commentaireReleveNotesFormationCommentaire: etudiant.documents?.releveNotesFormationCommentaire?.commentaire || '',
      commentairePasseport: etudiant.documents?.passeport?.commentaire || '',
      commentaireBacOuAttestationBacCommentaire: etudiant.documents?.bacOuAttestationBacCommentaire?.commentaire || '',
      commentaireAuthentificationBac: etudiant.documents?.authentificationBac?.commentaire || '',
      commentaireAuthenticationDiplome: etudiant.documents?.authenticationDiplome?.commentaire || '',
      commentaireEngagementCommentaire: etudiant.documents?.engagementCommentaire?.commentaire || ''
    });

    console.log('✅ FormModifier mis à jour:', {
      filiere: etudiant.filiere,
      niveau: etudiant.niveau,
      specialiteLicencePro: etudiant.specialiteLicencePro,
      optionLicencePro: etudiant.optionLicencePro,
      specialiteMasterPro: etudiant.specialiteMasterPro,
      optionMasterPro: etudiant.optionMasterPro
    }); // Pour vérifier que ça marche

    setImageFileModifier(null);
    setMessageModifier('');
    setShowEditModal(true);
    setLockCoursModifier(false);
  };

  const closeEditModal = () => {
    setShowEditModal(false);
    setEtudiantAModifier(null);
    setFormModifier({
      prenom: '',
      nomDeFamille: '',
      genre: 'Homme',
      dateNaissance: '',
      telephone: '',
      anneeScolaire: genererAnneeScolaireActuelle(),
      email: '',
      motDePasse: '',
      cin: '',
      passeport: '',
      lieuNaissance: '',
      pays: '',
      cours: [],
      niveau: '',
      niveauFormation: '',
      filiere: '',
      option: '',
      specialite: '',
      typeDiplome: '',
      diplomeAcces: '',
      specialiteDiplomeAcces: '',
      mention: '',
      lieuObtentionDiplome: '',
      serieBaccalaureat: '',
      anneeBaccalaureat: '',
      premiereAnneeInscription: '',
      sourceInscription: '',
      dateInscription: '',
      typePaiement: '',
      modePaiement: 'mensuel',
      prixTotal: '',
      pourcentageBourse: '',
      situation: '',
      codeEtudiant: '',
      dateEtReglement: '',
      actif: true,
      nouvelleInscription: true,
      paye: false,
      handicape: false,
      resident: false,
      fonctionnaire: false,
      mobilite: false,
      commercial: '',
      cycle: '',
      specialiteIngenieur: '',
      optionIngenieur: '',
      // 🔥 AJOUT DES CHAMPS MANQUANTS
      specialiteLicencePro: '',
      optionLicencePro: '',
      specialiteMasterPro: '',
      optionMasterPro: '',
      // Nouveaux champs supplémentaires
      telephoneResponsable: '',
      codeBaccalaureat: '',
      codeMassar: '',
      // Nouveaux champs Partner
      isPartner: false,
      nomPartner: '',
      prixTotalPartner: ''
    });
    setDocumentsModifier({
      documentCin: null,
      documentBacCommentaire: null,
      documentReleveNoteBac: null,
      documentDiplomeCommentaire: null,
      documentAttestationReussiteCommentaire: null,
      documentReleveNotesFormationCommentaire: null,
      documentPasseport: null,
      documentBacOuAttestationBacCommentaire: null,
      documentAuthentificationBac: null,
      documentAuthenticationDiplome: null,
      documentEngagementCommentaire: null
    });
    setCommentairesModifier({
      commentaireCin: '',
      commentaireBacCommentaire: '',
      commentaireReleveNoteBac: '',
      commentaireDiplomeCommentaire: '',
      commentaireAttestationReussiteCommentaire: '',
      commentaireReleveNotesFormationCommentaire: '',
      commentairePasseport: '',
      commentaireBacOuAttestationBacCommentaire: '',
      commentaireAuthentificationBac: '',
      commentaireAuthenticationDiplome: '',
      commentaireEngagementCommentaire: ''
    });
    setImageFileModifier(null);
    setMessageModifier('');
    setLockCoursModifier(false);
  };

  // Handler de changement pour inclure les champs ingénieur
  const handleChangeAjout = (e) => {
    const { name, value, type, checked } = e.target;
    if ([
      'niveau', 'filiere', 'specialite', 'option', 'cycle',
      'specialiteIngenieur', 'optionIngenieur',
      'specialiteLicencePro', 'optionLicencePro',
      'specialiteMasterPro', 'optionMasterPro',
      'niveauFormation'
    ].includes(name)) {
      setLockCoursAjout(false);
      // Ne pas passer de valeurs vides pour les champs enum
      const cleanValue = type === 'checkbox' ? checked : (value || undefined);
      handleFormationChangeAjout(name, cleanValue);
      const newValue = type === 'checkbox' ? checked : value;
      setFormAjout(prev => {
        const next = { ...prev, [name]: newValue };
        // ✅ Automatisation pour Najat Serti
        if (name === 'commercial' && newValue === '69b147956d61ec1af84a14c6') {
          return {
            ...next,
            isPartner: true,
            nomPartner: '6a01ea5d4f811bffe9916232'
          };
        }
        return next;
      });
    }
  };

  // 🔥 MISE À JOUR DU handleChangeModifier pour inclure tous les champs :
  const handleChangeModifier = (e) => {
    const { name, value, type, checked } = e.target;
    // 🔥 AJOUT DES NOUVEAUX CHAMPS
    if ([
      'niveau', 'filiere', 'specialite', 'option', 'cycle',
      'specialiteIngenieur', 'optionIngenieur',
      'specialiteLicencePro', 'optionLicencePro',
      'specialiteMasterPro', 'optionMasterPro',
      'niveauFormation'
    ].includes(name)) {
      setLockCoursModifier(false);
      const newValue = type === 'checkbox' ? checked : (value || undefined);
      handleFormationChangeModifier(name, newValue);
    } else {
      const newValue = type === 'checkbox' ? checked : value;
      setFormModifier(prev => {
        const next = { ...prev, [name]: newValue };

        // ✅ AJOUTÉ : Si l'admin change l'année scolaire → nouvelleInscription = false automatiquement
        if (name === 'anneeScolaire' && newValue !== etudiantAModifier?.anneeScolaire) {
          next.nouvelleInscription = false;
        }

        // ✅ Automatisation pour Najat Serti
        if (name === 'commercial' && newValue === '69b147956d61ec1af84a14c6') {
          return {
            ...next,
            isPartner: true,
            nomPartner: '6a01ea5d4f811bffe9916232'
          };
        }
        return next;
      });
    }
  };

  const handleSelectCoursAjout = (coursNom) => {
    const nouveauxCours = formAjout.cours.includes(coursNom)
      ? formAjout.cours.filter(c => c !== coursNom)
      : [...formAjout.cours, coursNom];
    setFormAjout({ ...formAjout, cours: nouveauxCours });
    setLockCoursAjout(true);
  };

  const handleImageChangeAjout = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleDocumentChangeAjout = (e) => {
    const { name, files } = e.target;
    setDocumentsAjout(prev => ({
      ...prev,
      [name]: files[0] || null
    }));
  };

  const handleCommentaireChangeAjout = (e) => {
    const { name, value } = e.target;
    setCommentairesAjout(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitAjout = async (e) => {
    e.preventDefault();

    if (formAjout.filiere === 'CYCLE_INGENIEUR' && !formAjout.cycle && formAjout.niveau) {
      formAjout.cycle = getCycleParNiveau(formAjout.niveau);
    }

    const erreurAnneeScolaire = validerAnneeScolaire(formAjout.anneeScolaire);
    if (erreurAnneeScolaire) {
      setMessageAjout('❌ ' + erreurAnneeScolaire);
      return;
    }
    const erreursFormation = validerFormationComplete(formAjout);
    if (erreursFormation.length > 0) {
      setMessageAjout('❌ Erreurs de formation: ' + erreursFormation.join(', '));
      return;
    }
    setLoadingAjout(true);
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();

      // NETTOYER les données avant l'envoi
      const formAjoutClean = { ...formAjout };

      // Supprimer les champs non pertinents selon la filière
      if (isManualFiliere(formAjoutClean.filiere)) {
        delete formAjoutClean.cycle;
        delete formAjoutClean.specialiteIngenieur;
        delete formAjoutClean.optionIngenieur;
        delete formAjoutClean.specialiteLicencePro;
        delete formAjoutClean.optionLicencePro;
        delete formAjoutClean.specialiteMasterPro;
        delete formAjoutClean.optionMasterPro;
      } else if (formAjoutClean.filiere === 'CYCLE_INGENIEUR') {
        if (!formAjoutClean.cycle && formAjoutClean.niveau) {
          formAjoutClean.cycle = getCycleParNiveau(formAjoutClean.niveau);
        }
        delete formAjoutClean.specialiteLicencePro;
        delete formAjoutClean.optionLicencePro;
        delete formAjoutClean.specialiteMasterPro;
        delete formAjoutClean.optionMasterPro;
        delete formAjoutClean.specialite;
        delete formAjoutClean.option;
      } else if (formAjoutClean.filiere === 'LICENCE_PRO') {
        delete formAjoutClean.cycle;
        delete formAjoutClean.specialiteIngenieur;
        delete formAjoutClean.optionIngenieur;
        delete formAjoutClean.specialiteMasterPro;
        delete formAjoutClean.optionMasterPro;
        delete formAjoutClean.specialite;
        delete formAjoutClean.option;
      } else if (formAjoutClean.filiere === 'MASTER_PRO') {
        delete formAjoutClean.cycle;
        delete formAjoutClean.specialiteIngenieur;
        delete formAjoutClean.optionIngenieur;
        delete formAjoutClean.specialiteLicencePro;
        delete formAjoutClean.optionLicencePro;
        delete formAjoutClean.specialite;
        delete formAjoutClean.option;
      }

      Object.keys(formAjoutClean).forEach(key => {
        if (key === 'cours') {
          formAjoutClean[key].forEach(c => formData.append('cours[]', c));
        } else {
          const valeur = formAjoutClean[key];
          const valeurAEnvoyer = (valeur !== undefined && valeur !== null)
            ? (typeof valeur === 'boolean' ? valeur.toString() : valeur.toString())
            : '';
          formData.append(key, valeurAEnvoyer);
        }
      });
      if (imageFile) formData.append('image', imageFile);

      // Nouveaux documents avec commentaires
      Object.keys(documentsAjout).forEach(key => {
        if (documentsAjout[key]) {
          formData.append(key, documentsAjout[key]);
        }
      });

      // Commentaires des documents
      Object.keys(commentairesAjout).forEach(key => {
        formData.append(key, commentairesAjout[key]);
      });

      const response = await axios.post('    https://vmi1977988.contaboserver.net/api2/etudiants', formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'multipart/form-data'
        }
      });

      setMessageAjout('✅ Étudiant ajouté avec succès');
      setEtudiants([...etudiants, response.data]);
      await fetchEtudiants();

      setTimeout(() => {
        closeModal();
      }, 2000);
    } catch (err) {
      setMessageAjout('❌ Erreur: ' + (err.response?.data?.message || 'Erreur inconnue'));
    } finally {
      setLoadingAjout(false);
    }
  };

  const handleSelectCoursModifier = (coursNom) => {
    const nouveauxCours = formModifier.cours.includes(coursNom)
      ? formModifier.cours.filter(c => c !== coursNom)
      : [...formModifier.cours, coursNom];
    setFormModifier({ ...formModifier, cours: nouveauxCours });
    setLockCoursModifier(true);
  };

  const handleImageChangeModifier = (e) => {
    setImageFileModifier(e.target.files[0]);
  };

  const handleDocumentChangeModifier = (e) => {
    const { name, files } = e.target;
    setDocumentsModifier(prev => ({
      ...prev,
      [name]: files[0] || null
    }));
  };

  const handleCommentaireChangeModifier = (e) => {
    const { name, value } = e.target;
    setCommentairesModifier(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmitModifier = async (e) => {
    e.preventDefault();

    // Si filière ingénieur et cycle non renseigné, le déduire du niveau
    if (formModifier.filiere === 'CYCLE_INGENIEUR' && !formModifier.cycle && formModifier.niveau) {
      formModifier.cycle = getCycleParNiveau(formModifier.niveau);
    }

    // Validation de l'année scolaire
    const erreurAnneeScolaire = validerAnneeScolaire(formModifier.anneeScolaire);
    if (erreurAnneeScolaire) {
      setMessageModifier('❌ ' + erreurAnneeScolaire);
      return;
    }

    // Validation de la formation
    const erreursFormation = validerFormationComplete(formModifier);
    if (erreursFormation.length > 0) {
      setMessageModifier('❌ Erreurs de formation: ' + erreursFormation.join(', '));
      return;
    }

    setLoadingModifier(true);
    try {
      const token = localStorage.getItem('token');
      const formData = new FormData();

      // 🔥 SOLUTION: Nettoyer TOUTES les valeurs vides/undefined avant envoi
      const formModifierClean = { ...formModifier };

      // Fonction helper pour nettoyer les valeurs
      const cleanValue = (value) => {
        if (value === '' || value === undefined || value === null) {
          return undefined;
        }
        return value;
      };

      // Supprimer les champs non pertinents selon la filière
      if (isManualFiliere(formModifierClean.filiere)) {
        delete formModifierClean.cycle;
        delete formModifierClean.specialiteIngenieur;
        delete formModifierClean.optionIngenieur;
        delete formModifierClean.specialiteLicencePro;
        delete formModifierClean.optionLicencePro;
        delete formModifierClean.specialiteMasterPro;
        delete formModifierClean.optionMasterPro;
      } else if (formModifierClean.filiere === 'CYCLE_INGENIEUR') {
        if (!formModifierClean.cycle && formModifierClean.niveau) {
          formModifierClean.cycle = getCycleParNiveau(formModifierClean.niveau);
        }
        delete formModifierClean.specialiteLicencePro;
        delete formModifierClean.optionLicencePro;
        delete formModifierClean.specialiteMasterPro;
        delete formModifierClean.optionMasterPro;
        delete formModifierClean.specialite;
        delete formModifierClean.option;
      } else if (formModifierClean.filiere === 'LICENCE_PRO') {
        delete formModifierClean.cycle;
        delete formModifierClean.specialiteIngenieur;
        delete formModifierClean.optionIngenieur;
        delete formModifierClean.specialiteMasterPro;
        delete formModifierClean.optionMasterPro;
        delete formModifierClean.specialite;
        delete formModifierClean.option;
      } else if (formModifierClean.filiere === 'MASTER_PRO') {
        delete formModifierClean.cycle;
        delete formModifierClean.specialiteIngenieur;
        delete formModifierClean.optionIngenieur;
        delete formModifierClean.specialiteLicencePro;
        delete formModifierClean.optionLicencePro;
        delete formModifierClean.specialite;
        delete formModifierClean.option;
      }

      // 🔥 IMPORTANT: N'envoyer que les champs avec des valeurs valides
      Object.keys(formModifierClean).forEach(key => {
        if (key === 'cours') {
          formModifierClean[key].forEach(c => formData.append('cours[]', c));
        } else if (key === 'motDePasse' && formModifierClean[key].trim() === '') {
          return; // Ne pas envoyer mot de passe vide
        } else {
          const valeurNettoyee = cleanValue(formModifierClean[key]);

          // ✅ Ne pas ajouter au FormData si la valeur est undefined
          if (valeurNettoyee !== undefined) {
            formData.append(
              key,
              typeof valeurNettoyee === 'boolean'
                ? valeurNettoyee.toString()
                : valeurNettoyee.toString()
            );
          }
        }
      });

      if (imageFileModifier) formData.append('image', imageFileModifier);

      // Nouveaux documents avec commentaires
      Object.keys(documentsModifier).forEach(key => {
        if (documentsModifier[key]) {
          formData.append(key, documentsModifier[key]);
        }
      });

      // Commentaires des documents
      Object.keys(commentairesModifier).forEach(key => {
        const valeur = commentairesModifier[key];
        if (valeur && valeur.trim() !== '') {
          formData.append(key, valeur);
        }
      });

      const response = await axios.put(
        `     https://vmi1977988.contaboserver.net/api2/etudiants/${etudiantAModifier._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        }
      );

      setMessageModifier('✅ Étudiant modifié avec succès');
      await fetchEtudiants();
      setTimeout(() => {
        closeEditModal();
      }, 2000);

    } catch (err) {
      console.error('Erreur complète:', err.response?.data); // 🔥 Ajout pour debug
      setMessageModifier('❌ Erreur: ' + (err.response?.data?.message || err.response?.data?.error || 'Erreur inconnue'));
    } finally {
      setLoadingModifier(false);
    }
  };


  const handleToggleActif = async (id) => {
    const etudiant = etudiants.find(e => e._id === id);

    if (!etudiant) return;

    const action = etudiant.actif ? 'désactiver' : 'activer';
    const message = etudiant.actif
      ? "Désactiver cet étudiant ?\n\nIl n'apparaîtra plus dans les listes et statistiques"
      : "Activer cet étudiant ?\n\nIl redeviendra visible dans les listes";

    if (!window.confirm(message)) return;

    try {
      const token = localStorage.getItem('token');
      const res = await axios.patch(`     https://vmi1977988.contaboserver.net/api2/etudiants/${id}/actif`, {
        raison: `${action.charAt(0).toUpperCase() + action.slice(1)} depuis toggle`
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      // Mettre à jour la liste locale
      setEtudiants(etudiants.map(e => e._id === id ? res.data : e));

    } catch (err) {
      console.error('Erreur toggle actif:', err);
      alert(`❌ Erreur lors de l'action "${action}"`);
    }
  };



  const handleDelete = async (id) => {
    if (!window.confirm("🛑 Voulez-vous désactiver cet étudiant ?\n\n" +
      "✅ L'étudiant sera MASQUÉ mais pas supprimé définitivement\n" +
      "✅ Vous pourrez le restaurer depuis 'Étudiants Inactifs'\n" +
      "✅ Ses données seront conservées")) return;

    try {
      const token = localStorage.getItem('token');

      // Soft delete au lieu de suppression définitive
      await axios.delete(`     https://vmi1977988.contaboserver.net/api2/etudiants/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
        data: { raison: 'Désactivation depuis la liste admin' }
      });

      // Recharger la liste
      await fetchEtudiants();

      // Message de confirmation
      alert('✅ Étudiant désactivé avec succès\n\n' +
        '👉 Vous pouvez le restaurer depuis "Étudiants Inactifs"');

    } catch (err) {
      console.error('Erreur suppression:', err);
      alert('❌ Erreur lors de la désactivation');
    }
  };


  const handleEdit = (etudiant) => {
    openEditModal(etudiant);
  };

  const handleView = (etudiant) => {
    setEtudiantSelectionne(etudiant);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setEtudiantSelectionne(null);
  };

  const viderFiltres = () => {
    setRecherche('');
    setFiltreGenre('');
    setFiltreCours('');
    setFiltreActif('');
    setFiltreCommercial('');
    setFiltreAnneeScolaire('');
    setFiltrePartner('');
  };

  const formatDate = (isoDate) => {
    if (!isoDate) return 'N/A';
    const date = new Date(isoDate);
    const jour = String(date.getDate()).padStart(2, '0');
    const mois = String(date.getMonth() + 1).padStart(2, '0');
    const annee = date.getFullYear();
    return `${jour}-${mois}-${annee}`;
  };

  const calculerAge = (dateNaissance) => {
    if (!dateNaissance) return 'N/A';
    const dob = new Date(dateNaissance);
    const today = new Date();
    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }
    return age;
  };

  const getNomCommercial = (commercialId) => {
    if (!commercialId) return 'Aucun';
    if (typeof commercialId === 'object') {
      return commercialId.nomComplet || commercialId.nom || 'Aucun';
    }
    const commercial = listeCommerciaux.find(c => c._id === commercialId);
    return commercial ? (commercial.nomComplet || commercial.nom) : 'Commercial supprimé';
  };

  const getNomComplet = (etudiant) => {
    return `${etudiant.prenom || ''} ${etudiant.nomDeFamille || ''}`.trim();
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/';
  };

  // Fonction d'export Excel
  const exportToExcel = async () => {
    if (!exportAnneeScolaire) {
      alert('Veuillez sélectionner une option pour l\'export');
      return;
    }

    setLoadingExport(true);

    try {
      let etudiantsAExporter = [];
      let labelSheet = 'Tous_Les_Etudiants';

      if (exportAnneeScolaire === 'FILTRES') {
        etudiantsAExporter = etudiantsFiltres;
        labelSheet = 'Etudiants_Filtres';
      } else if (exportAnneeScolaire === 'TOUS' || exportAnneeScolaire === 'Toutes') {
        etudiantsAExporter = etudiants;
        labelSheet = 'Tous_Les_Etudiants';
      } else {
        etudiantsAExporter = etudiants.filter(e => e.anneeScolaire === exportAnneeScolaire);
        labelSheet = `Etudiants_${exportAnneeScolaire.replace('/', '-')}`;
      }

      if (etudiantsAExporter.length === 0) {
        alert('Aucun étudiant trouvé pour la sélection.');
        setLoadingExport(false);
        return;
      }

      // Préparer les données pour l'export
      const donneesExport = etudiantsAExporter.map(etudiant => ({
        'Code Étudiant': etudiant.codeEtudiant || 'N/A',
        'Prénom': etudiant.prenom || '',
        'Nom de Famille': etudiant.nomDeFamille || '',
        'Genre': etudiant.genre || '',
        'Date de Naissance': etudiant.dateNaissance ? new Date(etudiant.dateNaissance).toLocaleDateString('fr-FR') : 'N/A',
        'Téléphone': etudiant.telephone || '',
        'Email': etudiant.email || '',
        'CIN': etudiant.cin || 'N/A',
        'Passeport': etudiant.passeport || 'N/A',
        'Code Massar': etudiant.codeMassar || 'N/A',
        'Année Scolaire': etudiant.anneeScolaire || 'N/A',
        'Niveau Formation': etudiant.niveauFormation || 'N/A',
        'Filière': etudiant.filiere || 'N/A',
        'Niveau': etudiant.niveau || 'N/A',
        'Spécialité': etudiant.specialite || etudiant.specialiteIngenieur || etudiant.specialiteLicencePro || etudiant.specialiteMasterPro || 'N/A',
        'Option': etudiant.option || etudiant.optionIngenieur || etudiant.optionLicencePro || etudiant.optionMasterPro || 'N/A',
        'Cycle': etudiant.cycle || 'N/A',
        'Classes': etudiant.cours ? etudiant.cours.join(', ') : 'Aucune',
        'Type': etudiant.isPartner ? 'Partner' : 'Normal',
        'Prix Total': etudiant.prixTotal || '0',
        'Prix Partner': etudiant.prixTotalPartner || 'N/A',
        'Commercial': getNomCommercial(etudiant.commercial),
        'Lieu de Naissance': etudiant.lieuNaissance || 'N/A',
        'Pays': etudiant.pays || 'N/A',
        'Ville': etudiant.ville || 'N/A',
        'Quartier': etudiant.quartier || 'N/A',
        'Double Compétence IT': etudiant.doubleCompetenceIT ? 'Oui' : 'Non',
        'Mode Formation 2': etudiant.niveauFormation2 || 'N/A',
        'Filière 2': etudiant.filiere2 || 'N/A',
        'Spécialité 2': etudiant.specialite2 || 'N/A',
        'Option 2': etudiant.option2 || 'N/A',
        'Téléphone Responsable': etudiant.telephoneResponsable || 'N/A',
        'Code Baccalauréat': etudiant.codeBaccalaureat || 'N/A',
        'Diplôme d\'Accès': etudiant.diplomeAcces || 'N/A',
        'Spécialité Diplôme': etudiant.specialiteDiplomeAcces || 'N/A',
        'Mention': etudiant.mention || 'N/A',
        'Série Bac': etudiant.serieBaccalaureat || 'N/A',
        'Année Bac': etudiant.anneeBaccalaureat || 'N/A',
        'Date d\'Inscription': etudiant.dateInscription ? new Date(etudiant.dateInscription).toLocaleDateString('fr-FR') : 'N/A',
        'Mode Paiement': etudiant.modePaiement || 'N/A',
        'Pourcentage Bourse': etudiant.pourcentageBourse || '0',
        'Type Paiement': etudiant.typePaiement || 'N/A',
        'Situation': etudiant.situation || 'N/A',
        'Statut': etudiant.actif ? 'Actif' : 'Inactif',
        'Payé': etudiant.paye ? 'Oui' : 'Non',
        'Nouvelle Inscription': etudiant.nouvelleInscription ? 'Oui' : 'Non',
        'Handicapé': etudiant.handicape ? 'Oui' : 'Non',
        'Résident': etudiant.resident ? 'Oui' : 'Non',
        'Fonctionnaire': etudiant.fonctionnaire ? 'Oui' : 'Non',
        'Mobilité': etudiant.mobilite ? 'Oui' : 'Non',
        'Date de Création': etudiant.createdAt ? new Date(etudiant.createdAt).toLocaleDateString('fr-FR') : 'N/A'
      }));

      // Créer le fichier Excel
      const ws = XLSX.utils.json_to_sheet(donneesExport);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, labelSheet.substring(0, 31));

      // Ajuster la largeur des colonnes
      const maxWidth = donneesExport.reduce((w, r) => Math.max(w, Object.keys(r).length), 0);
      ws['!cols'] = Array(maxWidth).fill({ wch: 15 });

      // Télécharger le fichier
      const fileName = `${labelSheet}_${new Date().toISOString().split('T')[0]}.xlsx`;
      XLSX.writeFile(wb, fileName);

      // Fermer le modal et réinitialiser
      setShowExportModal(false);
      setExportAnneeScolaire('');
      alert(`Export réussi ! ${etudiantsAExporter.length} étudiants exportés dans ${fileName}`);

    } catch (error) {
      console.error('Erreur lors de l\'export:', error);
      alert('Erreur lors de l\'export. Veuillez réessayer.');
    } finally {
      setLoadingExport(false);
    }
  };

  const [loadingExportTDB, setLoadingExportTDB] = useState(false);

  const handleExportTDBPedagogie = async () => {
    try {
      setLoadingExportTDB(true);
      const token = localStorage.getItem('token');
      const response = await fetch(' https://vmi1977988.contaboserver.net/api2/etudiants/export-tdb-pedagogie', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error(`Erreur serveur (${response.status})`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'TDB_Pedagogie_Extraction_ENT.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Erreur export TDB Pédagogique:', err);
      alert('Erreur lors de l\'export TDB Pédagogique : ' + err.message);
    } finally {
      setLoadingExportTDB(false);
    }
  };

  const [loadingExportEffectifsClasse, setLoadingExportEffectifsClasse] = useState(false);

  const handleExportEffectifsParClasse = async () => {
    try {
      setLoadingExportEffectifsClasse(true);
      const token = localStorage.getItem('token');
      const response = await fetch(' https://vmi1977988.contaboserver.net/api2/etudiants/export-effectifs-par-classe', {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      if (!response.ok) {
        throw new Error(`Erreur serveur (${response.status})`);
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Effectifs_Etudiants_Par_Classe_2026-2027.xlsx';
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Erreur export Effectifs par Classe:', err);
      alert('Erreur lors du téléchargement Effectifs par Classe : ' + err.message);
    } finally {
      setLoadingExportEffectifsClasse(false);
    }
  };

  // Pagination
  const etudiantsParPageNum = etudiantsParPage === 'Tous' ? (etudiantsFiltres.length || 1) : Number(etudiantsParPage);
  const indexDernierEtudiant = pageActuelle * etudiantsParPageNum;
  const indexPremierEtudiant = indexDernierEtudiant - etudiantsParPageNum;
  const etudiantsActuels = etudiantsParPage === 'Tous'
    ? etudiantsFiltres
    : etudiantsFiltres.slice(indexPremierEtudiant, indexDernierEtudiant);
  const totalPages = etudiantsParPage === 'Tous' ? 1 : Math.ceil(etudiantsFiltres.length / etudiantsParPageNum);

  const changerPage = (numerePage) => {
    setPageActuelle(numerePage);
  };

  // Obtenir tous les cours uniques pour le filtre
  const coursUniques = [...new Set(etudiants.flatMap(e => e.cours || []))];

  // Obtenir toutes les années scolaires uniques pour le filtre
  const annesScolairesUniques = [...new Set(etudiants.map(e => e.anneeScolaire).filter(Boolean))];

  if (loading) {
    return <div className="loading">Chargement des étudiants...</div>;
  }

  return (
    <div className="liste-etudiants-container" style={{
      background: 'linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 25%, #f3e8ff 100%)'
    }}>
      <Sidebar onLogout={handleLogout} />

      <div className="header" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
        <h2 style={{ width: '100%', textAlign: 'center' }}>Liste des Étudiants</h2>
        <div className="header-actions">
          <div className="stats">
            Total: {etudiantsFiltres.length} étudiants
          </div>

          <div className="vue-toggle">
            <button
              onClick={() => setVueMode('tableau')}
              className={`btn-vue ${vueMode === 'tableau' ? 'active' : ''}`}
            >
              Tableau
            </button>
            <button
              onClick={() => setVueMode('carte')}
              className={`btn-vue ${vueMode === 'carte' ? 'active' : ''}`}
            >
              Cartes
            </button>
          </div>

          <button onClick={openModal} className="btn-ajouter-etudiant">
            Ajouter un étudiant
          </button>
          <button
            onClick={openModalInactifs}
            className="btn-etudiants-inactifs"
            title="Voir les étudiants désactivés"
          >
            <UserX size={20} />
            Étudiants Inactifs
          </button>
          <button onClick={() => setShowExportModal(true)} className="btn-export-excel">
            📊 Exporter Excel
          </button>
          <button
            onClick={handleExportTDBPedagogie}
            disabled={loadingExportTDB}
            className="btn-export-tdb"
            title="Télécharger le Tableau de Bord Pédagogique (Excel)"
          >
            <FileSpreadsheet size={18} />
            {loadingExportTDB ? 'Génération...' : 'TDB Pédagogique'}
          </button>
          <button
            onClick={handleExportEffectifsParClasse}
            disabled={loadingExportEffectifsClasse}
            className="btn-export-tdb"
            style={{ background: 'linear-gradient(135deg, #0d9488 0%, #059669 100%)', color: '#ffffff' }}
            title="Télécharger les Effectifs Étudiants Par Classe (Excel)"
          >
            <FileSpreadsheet size={18} />
            {loadingExportEffectifsClasse ? 'Téléchargement...' : 'Effectifs par Classe'}
          </button>
        </div>
      </div>

      {/* Section des filtres */}
      <div className="filtres-section">
        <div className="filtres-row">
          <div className="filtre-groupe">
            <label>Rechercher:</label>
            <input
              type="text"
              placeholder="Nom, téléphone, CIN, code..."
              value={recherche}
              onChange={(e) => setRecherche(e.target.value)}
              className="input-recherche"
            />
          </div>

          <div className="filtre-groupe">
            <label>Genre:</label>
            <select
              value={filtreGenre}
              onChange={(e) => setFiltreGenre(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous</option>
              <option value="Homme">Homme</option>
              <option value="Femme">Femme</option>
            </select>
          </div>

          <div className="filtre-groupe">
            <label>Classe:</label>
            <select
              value={filtreCours}
              onChange={(e) => setFiltreCours(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous les classes</option>
              {coursUniques.map(cours => (
                <option key={cours} value={cours}>{cours}</option>
              ))}
            </select>
          </div>

          <div className="filtre-groupe">
            <label>Statut:</label>
            <select
              value={filtreActif}
              onChange={(e) => setFiltreActif(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous</option>
              <option value="true">Actif</option>
              <option value="false">Inactif</option>
            </select>
          </div>

          <div className="filtre-groupe">
            <label>Commercial:</label>
            <select
              value={filtreCommercial}
              onChange={(e) => setFiltreCommercial(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous les commerciaux</option>
              {listeCommerciaux.map(commercial => (
                <option key={commercial._id} value={commercial._id}>
                  {commercial.nomComplet || commercial.nom}
                </option>
              ))}
            </select>
          </div>

          <div className="filtre-groupe">
            <label>Année Scolaire:</label>
            <select
              value={filtreAnneeScolaire}
              onChange={(e) => setFiltreAnneeScolaire(e.target.value)}
              className="select-filtre"
            >
              <option value="">Toutes les années</option>
              {annesScolairesUniques.map(annee => (
                <option key={annee} value={annee}>{annee}</option>
              ))}
            </select>
          </div>

          <div className="filtre-groupe">
            <label>Type:</label>
            <select
              value={filtrePartner}
              onChange={(e) => setFiltrePartner(e.target.value)}
              className="select-filtre"
            >
              <option value="">Tous les types</option>
              <option value="true">Partners</option>
              <option value="false">Normaux</option>
            </select>
          </div>

          <div className="filtre-groupe" style={{ minWidth: '160px' }}>
            <label style={{ fontWeight: '600', color: '#1e293b' }}>Affichage / Page:</label>
            <select
              value={etudiantsParPage}
              onChange={(e) => {
                const val = e.target.value === 'Tous' ? 'Tous' : Number(e.target.value);
                setEtudiantsParPage(val);
                setPageActuelle(1);
              }}
              className="select-filtre"
              style={{
                fontWeight: 'bold',
                color: etudiantsParPage === 'Tous' ? '#1d4ed8' : '#1e293b',
                backgroundColor: etudiantsParPage === 'Tous' ? '#eff6ff' : '#ffffff',
                borderColor: etudiantsParPage === 'Tous' ? '#3b82f6' : '#cbd5e1'
              }}
            >
              <option value={10}>10 par page</option>
              <option value={25}>25 par page</option>
              <option value={50}>50 par page</option>
              <option value={100}>100 par page</option>
              <option value={250}>250 par page</option>
              <option value={500}>500 par page</option>
              <option value="Tous">⚡ Tous (Voir tout sur 1 page)</option>
            </select>
          </div>

          <button onClick={viderFiltres} className="btn-vider-filtres">
            Vider les filtres
          </button>
        </div>
      </div>

      {/* Vue Tableau ou Cartes */}
      {vueMode === 'tableau' ? (
        // VUE TABLEAU
        <div className="tableau-container">
          <table className="tableau-etudiants">
            <thead>
              <tr>
                <th>Nom Complet</th>
                <th>Genre</th>
                <th>Date de Naissance</th>
                <th>Téléphone</th>
                <th>Email</th>
                <th>Validation Pédagogique</th>

                <th>CIN</th>
                <th>Code Massar</th>
                <th>Code Étudiant</th>
                <th>N° Reçu</th>
                <th>Type</th>
                <th>Validation Pédagogique</th>
                <th>Commercial</th>
                <th>Classe</th>
                <th>Statut</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {etudiantsActuels.length === 0 ? (
                <tr>
                  <td colSpan="15" className="aucun-resultat">
                    Aucun étudiant trouvé
                  </td>
                </tr>
              ) : (
                etudiantsActuels.map((e) => (
                  <tr
                    key={e._id}
                    className={e.desistement?.statut ? 'etudiant-desiste' : ''}
                  >                    <td className="nom-colonne">{getNomComplet(e)}</td>
                    <td>{e.genre}</td>
                    <td>{formatDate(e.dateNaissance)}</td>
                    <td>{e.telephone}</td>
                    <td>{e.email}</td>
                    <td className="validation-colonne">
                      <span className={`validation-badge ${e.validationPedagogique?.statut === 'Validé' ? 'valide' :
                        e.validationPedagogique?.statut === 'Pas Validé' ? 'pas-valide' :
                          e.validationPedagogique?.statut === 'En cours' ? 'en-cours' : 'en-attente'
                        }`}>
                        {e.validationPedagogique?.statut || 'En attente'}
                      </span>
                      {e.validationPedagogique?.commentaire && (
                        <div className="validation-commentaire" title={e.validationPedagogique.commentaire}>
                          💬 {e.validationPedagogique.commentaire.substring(0, 20)}...
                        </div>
                      )}
                    </td>
                    <td>{e.cin || 'N/A'}</td>
                    <td>{e.codeMassar || 'N/A'}</td>
                    <td>{e.codeEtudiant || 'N/A'}</td>
                    <td><strong style={{ color: '#2563eb' }}>{e.numRecu || 'N/A'}</strong></td>
                    <td className="type-colonne">
                      <span className={`type-badge ${e.isPartner ? 'partner' : 'normal'}`}>
                        {e.isPartner ? '🤝 Partner' : '👤 Normal'}
                      </span>
                    </td>

                    <td className="commercial-colonne">
                      {getNomCommercial(e.commercial)}
                    </td>
                    <td className="cours-colonne">
                      {e.cours ? e.cours.join(', ') : 'Aucun'}
                    </td>
                    <td className="statut-colonne">
                      <div className="toggle-switch-container">
                        <span className={`statut-text ${e.actif ? 'actif' : 'inactif'}`}>
                          {e.actif ? 'Actif' : 'Inactif'}
                        </span>
                        <label className="toggle-switch">
                          <input
                            type="checkbox"
                            checked={e.actif}
                            onChange={() => handleToggleActif(e._id)}
                          />
                          <span className="slider"></span>
                        </label>
                      </div>
                    </td>
                    <td className="image-colonne">
                      {e.image ? (
                        <img
                          src={`     https://vmi1977988.contaboserver.net${e.image}`}
                          alt={getNomComplet(e)}
                          className="image-etudiant"
                        />
                      ) : (
                        <div className="pas-image">N/A</div>
                      )}
                    </td>
                    <td className="actions-colonne">
                      <button
                        onClick={() => handleView(e)}
                        className="btn-voir"
                      >
                        <Eye size={16} />
                      </button>
                      <button
                        onClick={() => handleEdit(e)}
                        className="btn-modifier"
                      >
                        <Edit size={16} />
                      </button>
                      <button
                        onClick={() => openDesistementModal(e)}
                        className={`btn-desistement ${e.desistement?.statut ? 'desiste' : ''}`}
                        title={e.desistement?.statut ? 'Gérer désistement' : 'Marquer comme désisté'}
                      >
                        <AlertTriangle size={16} />
                      </button>
                      <button
                        onClick={() => handleDelete(e._id)}
                        className="btn-supprimer"
                      >
                        <Trash2 size={16} />
                      </button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      ) : (
        // VUE CARTES
        <div className="cartes-container">
          {etudiantsActuels.length === 0 ? (
            <div className="aucun-resultat-cartes">
              Aucun étudiant trouvé
            </div>
          ) : (
            <div className="cartes-grid">
              {etudiantsActuels.map((e) => (
                <div key={e._id} className="carte-etudiant">
                  <div className="carte-header">
                    <div className="carte-image">
                      {e.image ? (
                        <img
                          src={`     https://vmi1977988.contaboserver.net${e.image}`}
                          alt="etudiant"
                          className="carte-photo"
                        />
                      ) : (
                        <div className="carte-placeholder">
                          <User size={24} />
                        </div>
                      )}
                    </div>
                    <div className="carte-statut">
                      <span className={`statut-badge ${e.actif ? 'actif' : 'inactif'}`}>
                        {e.actif ? <CheckCircle size={16} /> : <XCircle size={16} />}
                      </span>
                    </div>
                  </div>

                  <div className="carte-content">
                    <h3 className="carte-nom">{getNomComplet(e)}</h3>
                    <div className="carte-info">
                      <div className="carte-detail">
                        <span className="carte-label">Année Scolaire:</span>
                        <span>
                          <Calendar size={16} className="inline mr-1" />
                          {e.anneeScolaire || 'N/A'}
                        </span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Genre:</span>
                        <span>
                          <User size={16} className="inline mr-1" /> {e.genre}
                        </span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Âge:</span>
                        <span>{calculerAge(e.dateNaissance)} ans</span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Téléphone:</span>
                        <span>
                          <Phone size={16} className="inline mr-1" /> {e.telephone}
                        </span>
                      </div>
                      <div className="carte-detail">
                        <span className="carte-label">Email:</span>
                        <span>{e.email}</span>
                      </div>
                      {e.cin && (
                        <div className="carte-detail">
                          <span className="carte-label">CIN:</span>
                          <span>
                            <IdCard size={16} className="inline mr-1" /> {e.cin}
                          </span>
                        </div>
                      )}
                      {e.codeMassar && (
                        <div className="carte-detail">
                          <span className="carte-label">Code Massar:</span>
                          <span>
                            <IdCard size={16} className="inline mr-1" /> {e.codeMassar}
                          </span>
                        </div>
                      )}
                      {e.codeEtudiant && (
                        <div className="carte-detail">
                          <span className="carte-label">Code:</span>
                          <span>{e.codeEtudiant}</span>
                        </div>
                      )}
                      <div className="carte-detail">
                        <span className="carte-label">Type:</span>
                        <span className={`type-badge-card ${e.isPartner ? 'partner' : 'normal'}`}>
                          {e.isPartner ? '🤝 Partner' : '👤 Normal'}
                        </span>
                      </div>
                      {e.isPartner && e.nomPartner && (
                        <div className="carte-detail">
                          <span className="carte-label">Partenaire:</span>
                          <span>{e.nomPartner}</span>
                        </div>
                      )}
                      {e.isPartner && e.prixTotalPartner && (
                        <div className="carte-detail">
                          <span className="carte-label">Prix Partner:</span>
                          <span>{e.prixTotalPartner} DH</span>
                        </div>
                      )}
                      <div className="carte-detail">
                        <span className="carte-label">Commercial:</span>
                        <span>
                          <UserCheck size={16} className="inline mr-1" />
                          {getNomCommercial(e.commercial)}
                        </span>
                      </div>
                      <div className="carte-detail cours-detail">
                        <span className="carte-label">Classe:</span>
                        <div className="carte-cours">
                          {e.cours && e.cours.length > 0 ? (
                            e.cours.map((cours, index) => (
                              <span key={index} className="cours-tag">{cours}</span>
                            ))
                          ) : (
                            <span className="no-cours">Aucun classe</span>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="carte-actions">
                    <button
                      onClick={() => handleView(e)}
                      className="btn-carte btn-voir"
                      title="Voir détails"
                    >
                      <Eye size={16} />
                    </button>
                    <button
                      onClick={() => handleEdit(e)}
                      className="btn-carte btn-modifier"
                      title="Modifier"
                    >
                      <Edit size={16} />
                    </button>
                    <button
                      onClick={() => handleToggleActif(e._id)}
                      className="btn-carte btn-toggle"
                      title={e.actif ? 'Désactiver' : 'Activer'}
                    >
                      <RotateCcw size={16} />
                    </button>
                    <button
                      onClick={() => handleDelete(e._id)}
                      className="btn-carte btn-supprimer"
                      title="Supprimer"
                    >
                      <Trash2 size={16} />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="pagination">
          <button
            onClick={() => changerPage(pageActuelle - 1)}
            disabled={pageActuelle === 1}
            className="btn-pagination"
          >
            Précédent
          </button>

          {Array.from({ length: totalPages }, (_, i) => (
            <button
              key={i + 1}
              onClick={() => changerPage(i + 1)}
              className={`btn-pagination ${pageActuelle === i + 1 ? 'active' : ''}`}
            >
              {i + 1}
            </button>
          ))}

          <button
            onClick={() => changerPage(pageActuelle + 1)}
            disabled={pageActuelle === totalPages}
            className="btn-pagination"
          >
            Suivant
          </button>
        </div>
      )}

      {/* Modal d'ajout d'étudiant */}
      {showModal && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Ajouter un étudiant</h3>
              <button className="btn-fermer-modal" onClick={closeModal}>×</button>
            </div>

            <form onSubmit={handleSubmitAjout} className="form-ajout-etudiant">
              {/* Section Informations personnelles */}
              <div className="form-section">
                <h4><User size={20} className="inline mr-2" />Informations personnelles</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Prénom *</label>
                    <input
                      type="text"
                      name="prenom"
                      placeholder="Prénom"
                      value={formAjout.prenom}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Nom de Famille *</label>
                    <input
                      type="text"
                      name="nomDeFamille"
                      placeholder="Nom de famille"
                      value={formAjout.nomDeFamille}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Genre *</label>
                    <select name="genre" value={formAjout.genre} onChange={handleChangeAjout}>
                      <option value="Homme">Homme</option>
                      <option value="Femme">Femme</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Date de Naissance *</label>
                    <input
                      type="date"
                      name="dateNaissance"
                      value={formAjout.dateNaissance}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Téléphone *</label>
                    <input
                      type="text"
                      name="telephone"
                      placeholder="Téléphone"
                      value={formAjout.telephone}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formAjout.email}
                      onChange={handleChangeAjout}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>CIN</label>
                    <input
                      type="text"
                      name="cin"
                      placeholder="Numéro CIN"
                      value={formAjout.cin}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Passeport</label>
                    <input
                      type="text"
                      name="passeport"
                      placeholder="Numéro passeport"
                      value={formAjout.passeport}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Lieu de Naissance</label>
                    <input
                      type="text"
                      name="lieuNaissance"
                      placeholder="Lieu de naissance"
                      value={formAjout.lieuNaissance}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Pays *</label>
                    <select
                      name="pays"
                      value={formAjout.pays}
                      onChange={handleChangeAjout}
                      required
                    >
                      <option value="">Sélectionner un pays...</option>
                      {PAYS_LIST.map((pays) => (
                        <option key={pays} value={pays}>{pays}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Ville</label>
                    <input
                      type="text"
                      name="ville"
                      placeholder="Ville (ex: Casablanca)"
                      value={formAjout.ville || ''}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Quartier</label>
                    <input
                      type="text"
                      name="quartier"
                      placeholder="Quartier (ex: Maarif)"
                      value={formAjout.quartier || ''}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Téléphone du Responsable</label>
                    <input
                      type="text"
                      name="telephoneResponsable"
                      placeholder="Téléphone du responsable"
                      value={formAjout.telephoneResponsable}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Code du Baccalauréat</label>
                    <input
                      type="text"
                      name="codeBaccalaureat"
                      placeholder="Code du baccalauréat"
                      value={formAjout.codeBaccalaureat}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Code Massar</label>
                    <input
                      type="text"
                      name="codeMassar"
                      placeholder="Code Massar"
                      value={formAjout.codeMassar}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Mot de Passe *</label>
                  <input
                    type="password"
                    name="motDePasse"
                    placeholder="Mot de passe"
                    value={formAjout.motDePasse}
                    onChange={handleChangeAjout}
                    required
                    minLength="6"
                  />
                </div>
              </div>

              {/* Section Formation Intelligente */}
              <div className="form-section">
                <h4><GraduationCap size={20} className="inline mr-2" />Formation Intelligente</h4>

                {/* Nouveau champ année scolaire */}
                <div className="form-row">
                  <div className="form-group">
                    <label>Année Scolaire *</label>
                    <input
                      type="text"
                      name="anneeScolaire"
                      placeholder="YYYY/YYYY (ex: 2025/2026)"
                      value={formAjout.anneeScolaire}
                      onChange={handleChangeAjout}
                      required
                      pattern="^\d{4}/\d{4}$"
                      title="Format: YYYY/YYYY (ex: 2025/2026)"
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Format obligatoire: YYYY/YYYY (ex: 2025/2026)
                    </small>
                  </div>
                </div>
                <div className="form-group">
                  <label>Niveau de Formation</label>
                  <select
                    name="niveauFormation"
                    value={formAjout.niveauFormation}
                    onChange={handleChangeAjout}
                  >
                    <option value="">Sélectionner...</option>
                    <option value="FI">FI</option>
                    <option value="TA">TA</option>
                    <option value="Executive">Executive</option>
                    <option value="VAE">VAE</option>
                  </select>
                </div>
                <FormationSelector
                  form={formAjout}
                  onChange={handleFormationChangeAjout}
                />

                <div className="form-row">

                  <div className="form-group">
                    <label>Type de Diplôme</label>
                    <input
                      type="text"
                      name="typeDiplome"
                      placeholder="Type de diplôme"
                      value={formAjout.typeDiplome}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Classes</label>
                  {coursFiltres.length > 0 ? (
                    <div className="cours-selection-container">
                      {coursFiltres.map((cours) => (
                        <div
                          key={cours._id}
                          className={`cours-chip ${formAjout.cours.includes(cours.nom) ? 'selected' : ''}`}
                          onClick={() => handleSelectCoursAjout(cours.nom)}
                        >
                          <span className="cours-nom">{cours.nom}</span>
                          {formAjout.cours.includes(cours.nom) && (
                            <span className="cours-check">✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ color: '#666', textAlign: 'center' }}>
                      Sélectionnez votre formation d'abord
                    </p>
                  )}
                </div>
              </div>

              {/* Section Diplôme d'accès */}
              <div className="form-section">
                <h4><Award size={20} className="inline mr-2" />Diplôme d'accès</h4>

                {/* 🎯 COMPOSANT DiplomeSelectors intégré */}
                <DiplomeSelectors
                  form={formAjout}
                  onChange={handleChangeAjout}
                />

                {/* Champs complémentaires */}
                <div className="form-row">
                  <div className="form-group">
                    <label>Spécialité Diplôme d'Accès</label>
                    <input
                      type="text"
                      name="specialiteDiplomeAcces"
                      placeholder="Spécialité du diplôme d'accès"
                      value={formAjout.specialiteDiplomeAcces}
                      onChange={handleChangeAjout}
                    />
                  </div>
                  <div className="form-group">
                    <label>Mention</label>
                    <input
                      type="text"
                      name="mention"
                      placeholder="Mention"
                      value={formAjout.mention}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Année Baccalauréat</label>
                    <input
                      type="number"
                      name="anneeBaccalaureat"
                      placeholder="Année du baccalauréat"
                      value={formAjout.anneeBaccalaureat}
                      onChange={handleChangeAjout}
                      min="1900"
                      max={new Date().getFullYear()}
                    />
                  </div>
                  <div className="form-group">
                    <label>Première Année d'Inscription</label>
                    <input
                      type="number"
                      name="premiereAnneeInscription"
                      placeholder="Première année d'inscription"
                      value={formAjout.premiereAnneeInscription}
                      onChange={handleChangeAjout}
                      min="1900"
                      max={new Date().getFullYear() + 10}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Source d'Inscription</label>
                    <select
                      name="sourceInscription"
                      value={formAjout.sourceInscription}
                      onChange={handleChangeAjout}
                    >
                      <option value="">Sélectionner la source...</option>
                      {SOURCES_INSCRIPTION.map((src) => (
                        <option key={src} value={src}>{src}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Date d'Inscription</label>
                    <input
                      type="date"
                      name="dateInscription"
                      value={formAjout.dateInscription}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>
              </div>

              {/* Section Système Partner */}
              <div className="form-section">
                <h4>🤝 Système Partner</h4>

                <div className="form-row">
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="isPartner"
                        checked={formAjout.isPartner}
                        onChange={handleChangeAjout}
                      />
                      Étudiant Partenaire
                    </label>
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Cocher si cet étudiant fait partie du programme partenaire
                    </small>
                  </div>
                </div>

                {formAjout.isPartner && (
                  <div className="form-row">
                    <div className="form-group">
                      <label>Nom du Partenaire *</label>
                      <input
                        type="text"
                        name="nomPartner"
                        placeholder="Nom du partenaire"
                        value={formAjout.nomPartner}
                        onChange={handleChangeAjout}
                        required={formAjout.isPartner}
                      />
                      <small style={{ color: '#666', fontSize: '12px' }}>
                        Nom de l'organisation partenaire
                      </small>
                    </div>
                    <div className="form-group">
                      <label>Prix Total Partner *</label>
                      <input
                        type="number"
                        name="prixTotalPartner"
                        placeholder="Prix total pour partner"
                        value={formAjout.prixTotalPartner}
                        onChange={handleChangeAjout}
                        required={formAjout.isPartner}
                        min="1000"
                        max="99999"
                        step="1"
                      />
                      <small style={{ color: '#666', fontSize: '12px' }}>
                        Prix spécial pour les étudiants partenaires (séparé du prix normal)
                      </small>
                    </div>
                  </div>
                )}
              </div>

              {/* Section Inscription et Paiement */}
              <div className="form-section">
                <h4><CreditCard size={20} className="inline mr-2" />Inscription et Paiement</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Code Étudiant</label>
                    <input
                      type="text"
                      name="codeEtudiant"
                      placeholder="Code étudiant (généré automatiquement)"
                      value={formAjout.codeEtudiant}
                      onChange={handleChangeAjout}
                      readOnly
                      style={{ backgroundColor: '#f0f0f0' }}
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Le code sera généré automatiquement basé sur la formation et le nom
                    </small>
                  </div>
                  <div className="form-group">
                    <label>Commercial</label>
                    <select
                      name="commercial"
                      value={formAjout.commercial}
                      onChange={handleChangeAjout}
                    >
                      <option value="">Aucun commercial assigné</option>
                      {listeCommerciaux.map((commercial) => (
                        <option key={commercial._id} value={commercial._id}>
                          {commercial.nomComplet || commercial.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Mode de Paiement *</label>
                    <select
                      name="modePaiement"
                      value={formAjout.modePaiement}
                      onChange={handleChangeAjout}
                      required
                    >
                      <option value="semestriel">Semestriel (2 tranches)</option>
                      <option value="trimestriel">Trimestriel (3 tranches)</option>
                      <option value="mensuel">Mensuel (10 tranches)</option>
                      <option value="annuel">Annuel (paiement complet)</option>
                    </select>
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Semestriel par défaut. Annuel = paiement immédiat complet.
                    </small>
                  </div>
                  {formAjout.anneeScolaire === '2026/2027' && !formAjout.isPartner ? (
                    <div className="form-group">
                      <label>Type de Remise / Bourse (Grille 2026/2027)</label>
                      <select
                        name="typeRemise"
                        value={formAjout.typeRemise || 'none'}
                        onChange={handleChangeAjout}
                      >
                        {REMISES_LIST.map(r => (
                          <option key={r.id} value={r.id}>{r.label}</option>
                        ))}
                      </select>
                    </div>
                  ) : !formAjout.isPartner ? (
                    <div className="form-group">
                      <label>Prix Total</label>
                      <input
                        type="number"
                        name="prixTotal"
                        placeholder="Prix total (optionnel)"
                        value={formAjout.prixTotal}
                        onChange={handleChangeAjout}
                        min="0"
                        max="99999"
                        step="1"
                      />
                      <small style={{ color: '#666', fontSize: '12px' }}>
                        Champ optionnel - peut être rempli plus tard
                      </small>
                    </div>
                  ) : null}
                </div>

                {formAjout.anneeScolaire === '2026/2027' && !formAjout.isPartner && (
                  <div style={{ padding: '0 15px' }}>
                    {formAjout.typeRemise === 'custom' && (
                      <div className="form-group" style={{ marginBottom: '16px' }}>
                        <label>Montant de la Remise Exceptionnelle (DH)</label>
                        <input
                          type="number"
                          name="remiseMontant"
                          placeholder="Entrez le montant de la remise"
                          value={formAjout.remiseMontant || ''}
                          onChange={handleChangeAjout}
                          min="0"
                          max={formAjout.fraisScolariteBase || 35000}
                        />
                      </div>
                    )}
                    {/* Breakdown récapitulatif */}
                    <div className="pricing-breakdown" style={{
                      backgroundColor: '#f8fafc',
                      border: '1px solid #cbd5e1',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      marginBottom: '16px',
                      fontSize: '14px',
                      color: '#334155'
                    }}>
                      <h5 style={{ margin: '0 0 8px 0', color: '#1e293b', fontWeight: '600' }}>Récapitulatif des tarifs (PV 2026-2027)</h5>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span>Frais de scolarité de base :</span>
                        <span style={{ fontWeight: '500' }}>{(formAjout.fraisScolariteBase || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span>Frais d'inscription :</span>
                        <span style={{ fontWeight: '500' }}>{(formAjout.fraisInscription || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', color: '#dc2626' }}>
                        <span>Remise appliquée ({formAjout.pourcentageBourse || 0}%) :</span>
                        <span style={{ fontWeight: '500' }}>-{(formAjout.remiseMontant || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                      <div style={{ borderTop: '1px solid #cbd5e1', marginTop: '8px', paddingTop: '8px', display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', color: '#0f172a' }}>
                        <span>Total Net à payer :</span>
                        <span>{(formAjout.prixTotal || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                    </div>
                  </div>
                )}

                <div className="form-row">
                  {!(formAjout.anneeScolaire === '2026/2027' && !formAjout.isPartner) && (
                    <div className="form-group">
                      <label>Pourcentage Bourse (%)</label>
                      <input
                        type="number"
                        name="pourcentageBourse"
                        placeholder="Pourcentage de bourse"
                        value={formAjout.pourcentageBourse}
                        onChange={handleChangeAjout}
                        min="0"
                        max="100"
                      />
                    </div>
                  )}
                  <div className="form-group">
                    <label>Type de Paiement</label>
                    <input
                      type="text"
                      name="typePaiement"
                      placeholder="Type de paiement"
                      value={formAjout.typePaiement}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Situation</label>
                    <input
                      type="text"
                      name="situation"
                      placeholder="Situation"
                      value={formAjout.situation}
                      onChange={handleChangeAjout}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Date et Règlement</label>
                  <input
                    type="text"
                    name="dateEtReglement"
                    placeholder="Date et règlement"
                    value={formAjout.dateEtReglement}
                    onChange={handleChangeAjout}
                  />
                </div>
              </div>

              {/* Section Autres informations */}
              <div className="form-section">
                <h4><FileText size={20} className="inline mr-2" />Autres informations</h4>

                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChangeAjout}
                  />
                </div>

                {/* Section Documents avec commentaires */}
                <div className="documents-section">
                  <h5>Documents avec Commentaires</h5>

                  {/* CIN */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document CIN</label>
                      <input
                        type="file"
                        name="documentCin"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire CIN</label>
                      <input
                        type="text"
                        name="commentaireCin"
                        placeholder="Commentaire pour le CIN"
                        value={commentairesAjout.commentaireCin}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Bac avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Bac</label>
                      <input
                        type="file"
                        name="documentBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac</label>
                      <input
                        type="text"
                        name="commentaireBacCommentaire"
                        placeholder="Commentaire pour le Bac"
                        value={commentairesAjout.commentaireBacCommentaire}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Relevé de Notes Bac */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Relevé de Notes Bac</label>
                      <input
                        type="file"
                        name="documentReleveNoteBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Bac</label>
                      <input
                        type="text"
                        name="commentaireReleveNoteBac"
                        placeholder="Commentaire pour le relevé de notes bac"
                        value={commentairesAjout.commentaireReleveNoteBac}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Bac ou Attestation Bac avec commentaire - NOUVEAU */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Bac ou Attestation Bac</label>
                      <input
                        type="file"
                        name="documentBacOuAttestationBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac/Attestation</label>
                      <input
                        type="text"
                        name="commentaireBacOuAttestationBacCommentaire"
                        placeholder="Commentaire pour le bac ou attestation"
                        value={commentairesAjout.commentaireBacOuAttestationBacCommentaire}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Authentification Bac - NOUVEAU */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Authentification Bac</label>
                      <input
                        type="file"
                        name="documentAuthentificationBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentification Bac</label>
                      <input
                        type="text"
                        name="commentaireAuthentificationBac"
                        placeholder="Commentaire pour l'authentification bac"
                        value={commentairesAjout.commentaireAuthentificationBac}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Diplôme avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Diplôme</label>
                      <input
                        type="file"
                        name="documentDiplomeCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Diplôme</label>
                      <input
                        type="text"
                        name="commentaireDiplomeCommentaire"
                        placeholder="Commentaire pour le diplôme"
                        value={commentairesAjout.commentaireDiplomeCommentaire}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Authentication Diplôme - NOUVEAU */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Authentication Diplôme</label>
                      <input
                        type="file"
                        name="documentAuthenticationDiplome"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentication Diplôme</label>
                      <input
                        type="text"
                        name="commentaireAuthenticationDiplome"
                        placeholder="Commentaire pour l'authentication diplôme"
                        value={commentairesAjout.commentaireAuthenticationDiplome}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Attestation de Réussite avec commentaire - NOUVEAU */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Attestation de Réussite</label>
                      <input
                        type="file"
                        name="documentAttestationReussiteCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Attestation de Réussite</label>
                      <input
                        type="text"
                        name="commentaireAttestationReussiteCommentaire"
                        placeholder="Commentaire pour l'attestation de réussite"
                        value={commentairesAjout.commentaireAttestationReussiteCommentaire}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Relevé de Notes Formation avec commentaire - NOUVEAU */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Relevé de Notes Formation</label>
                      <input
                        type="file"
                        name="documentReleveNotesFormationCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Formation</label>
                      <input
                        type="text"
                        name="commentaireReleveNotesFormationCommentaire"
                        placeholder="Commentaire pour le relevé de notes formation"
                        value={commentairesAjout.commentaireReleveNotesFormationCommentaire}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Passeport */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Passeport</label>
                      <input
                        type="file"
                        name="documentPasseport"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Passeport</label>
                      <input
                        type="text"
                        name="commentairePasseport"
                        placeholder="Commentaire pour le passeport"
                        value={commentairesAjout.commentairePasseport}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>

                  {/* Engagement avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Engagement</label>
                      <input
                        type="file"
                        name="documentEngagementCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeAjout}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Engagement</label>
                      <input
                        type="text"
                        name="commentaireEngagementCommentaire"
                        placeholder="Commentaire pour l'engagement"
                        value={commentairesAjout.commentaireEngagementCommentaire}
                        onChange={handleCommentaireChangeAjout}
                      />
                    </div>
                  </div>
                </div>

                <div className="checkbox-grid">
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="actif"
                        checked={formAjout.actif}
                        onChange={handleChangeAjout}
                      />
                      Étudiant actif
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="paye"
                        checked={formAjout.paye}
                        onChange={handleChangeAjout}
                      />
                      Payé
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="nouvelleInscription"
                        checked={formAjout.nouvelleInscription}
                        onChange={handleChangeAjout}
                      />
                      Nouvelle inscription
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="handicape"
                        checked={formAjout.handicape}
                        onChange={handleChangeAjout}
                      />
                      Handicapé
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="resident"
                        checked={formAjout.resident}
                        onChange={handleChangeAjout}
                      />
                      Résident
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="fonctionnaire"
                        checked={formAjout.fonctionnaire}
                        onChange={handleChangeAjout}
                      />
                      Fonctionnaire
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="mobilite"
                        checked={formAjout.mobilite}
                        onChange={handleChangeAjout}
                      />
                      Mobilité
                    </label>
                  </div>
                </div>
              </div>

              {messageAjout && (
                <div className={`message-ajout ${messageAjout.includes('✅') ? 'success' : 'error'}`}>
                  {messageAjout}
                </div>
              )}

              <div className="modal-actions">
                <button type="button" onClick={closeModal} className="btn-annuler">
                  Annuler
                </button>
                <button type="submit" disabled={loadingAjout} className="btn-enregistrer">
                  {loadingAjout ? 'Enregistrement...' : 'Enregistrer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de modification d'étudiant */}
      {showEditModal && etudiantAModifier && (
        <div className="modal-overlay" onClick={closeEditModal}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Modifier l'étudiant</h3>
              <button className="btn-fermer-modal" onClick={closeEditModal}>×</button>
            </div>

            <form onSubmit={handleSubmitModifier} className="form-ajout-etudiant">
              {/* Section Informations personnelles */}
              <div className="form-section">
                <h4><User size={20} className="inline mr-2" />Informations personnelles</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Prénom *</label>
                    <input
                      type="text"
                      name="prenom"
                      placeholder="Prénom"
                      value={formModifier.prenom}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Nom de Famille *</label>
                    <input
                      type="text"
                      name="nomDeFamille"
                      placeholder="Nom de famille"
                      value={formModifier.nomDeFamille}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Genre *</label>
                    <select name="genre" value={formModifier.genre} onChange={handleChangeModifier}>
                      <option value="Homme">Homme</option>
                      <option value="Femme">Femme</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Date de Naissance *</label>
                    <input
                      type="date"
                      name="dateNaissance"
                      value={formModifier.dateNaissance}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Téléphone *</label>
                    <input
                      type="text"
                      name="telephone"
                      placeholder="Téléphone"
                      value={formModifier.telephone}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                  <div className="form-group">
                    <label>Email *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="Email"
                      value={formModifier.email}
                      onChange={handleChangeModifier}
                      required
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>CIN</label>
                    <input
                      type="text"
                      name="cin"
                      placeholder="Numéro CIN"
                      value={formModifier.cin}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Passeport</label>
                    <input
                      type="text"
                      name="passeport"
                      placeholder="Numéro passeport"
                      value={formModifier.passeport}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Lieu de Naissance</label>
                    <input
                      type="text"
                      name="lieuNaissance"
                      placeholder="Lieu de naissance"
                      value={formModifier.lieuNaissance}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Pays *</label>
                    <select
                      name="pays"
                      value={formModifier.pays}
                      onChange={handleChangeModifier}
                      required
                    >
                      <option value="">Sélectionner un pays...</option>
                      {PAYS_LIST.map((pays) => (
                        <option key={pays} value={pays}>{pays}</option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Ville</label>
                    <input
                      type="text"
                      name="ville"
                      placeholder="Ville (ex: Casablanca)"
                      value={formModifier.ville || ''}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Quartier</label>
                    <input
                      type="text"
                      name="quartier"
                      placeholder="Quartier (ex: Maarif)"
                      value={formModifier.quartier || ''}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Téléphone du Responsable</label>
                    <input
                      type="text"
                      name="telephoneResponsable"
                      placeholder="Téléphone du responsable"
                      value={formModifier.telephoneResponsable}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Code du Baccalauréat</label>
                    <input
                      type="text"
                      name="codeBaccalaureat"
                      placeholder="Code du baccalauréat"
                      value={formModifier.codeBaccalaureat}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Code Massar</label>
                    <input
                      type="text"
                      name="codeMassar"
                      placeholder="Code Massar"
                      value={formModifier.codeMassar}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Nouveau Mot de Passe</label>
                  <input
                    type="password"
                    name="motDePasse"
                    placeholder="Laisser vide pour garder l'ancien"
                    value={formModifier.motDePasse}
                    onChange={handleChangeModifier}
                    minLength="6"
                  />
                  <small style={{ color: '#666', fontSize: '12px' }}>
                    Laisser vide pour conserver le mot de passe actuel
                  </small>
                </div>
              </div>

              {/* Section Formation Intelligente */}
              <div className="form-section">
                <h4><GraduationCap size={20} className="inline mr-2" />Formation Intelligente</h4>

                <div className="form-row">
                  <div className="form-group">
                    <label>Année Scolaire *</label>
                    <input
                      type="text"
                      name="anneeScolaire"
                      placeholder="YYYY/YYYY (ex: 2025/2026)"
                      value={formModifier.anneeScolaire}
                      onChange={handleChangeModifier}
                      required
                      pattern="^\d{4}/\d{4}$"
                      title="Format: YYYY/YYYY (ex: 2025/2026)"
                    />
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Format obligatoire: YYYY/YYYY (ex: 2025/2026)
                    </small>
                  </div>
                </div>
                <div className="form-group">
                  <label>Niveau de Formation</label>
                  <select
                    name="niveauFormation"
                    value={formModifier.niveauFormation}
                    onChange={handleChangeModifier}
                  >
                    <option value="">Sélectionner...</option>
                    <option value="FI">FI</option>
                    <option value="TA">TA</option>
                    <option value="Executive">Executive</option>
                    <option value="VAE">VAE</option>
                  </select>
                </div>
                <FormationSelector
                  form={formModifier}
                  onChange={handleFormationChangeModifier}
                />

                <div className="form-row">

                  <div className="form-group">
                    <label>Type de Diplôme</label>
                    <input
                      type="text"
                      name="typeDiplome"
                      placeholder="Type de diplôme"
                      value={formModifier.typeDiplome}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Classes</label>
                  {coursFiltresModif.length > 0 ? (
                    <div className="cours-selection-container">
                      {coursFiltresModif.map((cours) => (
                        <div
                          key={cours._id}
                          className={`cours-chip ${formModifier.cours.includes(cours.nom) ? 'selected' : ''}`}
                          onClick={() => handleSelectCoursModifier(cours.nom)}
                        >
                          <span className="cours-nom">{cours.nom}</span>
                          {formModifier.cours.includes(cours.nom) && (
                            <span className="cours-check">✓</span>
                          )}
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={{ color: '#666', textAlign: 'center', padding: '10px' }}>
                      Sélectionnez d'abord votre formation complète
                    </p>
                  )}
                  {formModifier.cours.length > 0 && (
                    <div className="cours-selectionnes">
                      <small>Classes sélectionnées: {formModifier.cours.join(', ')}</small>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Diplôme d'accès */}
              <div className="form-section">
                <h4><Award size={20} className="inline mr-2" />Diplôme d'accès</h4>

                {/* 🎯 COMPOSANT DiplomeSelectors pour modification */}
                <DiplomeSelectors
                  form={formModifier}
                  onChange={handleChangeModifier}
                />

                {/* Champs complémentaires */}
                <div className="form-row">
                  <div className="form-group">
                    <label>Spécialité Diplôme d'Accès</label>
                    <input
                      type="text"
                      name="specialiteDiplomeAcces"
                      placeholder="Spécialité du diplôme d'accès"
                      value={formModifier.specialiteDiplomeAcces}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Mention</label>
                    <input
                      type="text"
                      name="mention"
                      placeholder="Mention"
                      value={formModifier.mention}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Année Baccalauréat</label>
                    <input
                      type="number"
                      name="anneeBaccalaureat"
                      placeholder="Année du baccalauréat"
                      value={formModifier.anneeBaccalaureat}
                      onChange={handleChangeModifier}
                      min="1900"
                      max={new Date().getFullYear()}
                    />
                  </div>
                  <div className="form-group">
                    <label>Première Année d'Inscription</label>
                    <input
                      type="number"
                      name="premiereAnneeInscription"
                      placeholder="Première année d'inscription"
                      value={formModifier.premiereAnneeInscription}
                      onChange={handleChangeModifier}
                      min="1900"
                      max={new Date().getFullYear() + 10}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Source d'Inscription</label>
                    <select
                      name="sourceInscription"
                      value={formModifier.sourceInscription}
                      onChange={handleChangeModifier}
                    >
                      <option value="">Sélectionner la source...</option>
                      {SOURCES_INSCRIPTION.map((src) => (
                        <option key={src} value={src}>{src}</option>
                      ))}
                    </select>
                  </div>
                  <div className="form-group">
                    <label>Date d'Inscription</label>
                    <input
                      type="date"
                      name="dateInscription"
                      value={formModifier.dateInscription}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>
              </div>
              {/* Section Système Partner */}
              <div className="form-section">
                <h4>🤝 Système Partner</h4>

                <div className="form-row">
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="isPartner"
                        checked={formModifier.isPartner}
                        onChange={handleChangeModifier}
                      />
                      Étudiant Partenaire
                    </label>
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Cocher si cet étudiant fait partie du programme partenaire
                    </small>
                  </div>
                </div>

                {formModifier.isPartner && (
                  <div className="form-row">
                    <div className="form-group">
                      <label>Nom du Partenaire *</label>
                      <input
                        type="text"
                        name="nomPartner"
                        placeholder="Nom du partenaire"
                        value={formModifier.nomPartner}
                        onChange={handleChangeModifier}
                        required={formModifier.isPartner}
                      />
                      <small style={{ color: '#666', fontSize: '12px' }}>
                        Nom de l'organisation partenaire
                      </small>
                    </div>
                    <div className="form-group">
                      <label>Prix Total Partner *</label>
                      <input
                        type="number"
                        name="prixTotalPartner"
                        placeholder="Prix total pour partner"
                        value={formModifier.prixTotalPartner}
                        onChange={handleChangeModifier}
                        required={formModifier.isPartner}
                        min="1000"
                        max="99999"
                        step="1"
                      />
                      <small style={{ color: '#666', fontSize: '12px' }}>
                        Prix spécial pour les étudiants partenaires (séparé du prix normal)
                      </small>
                    </div>
                  </div>
                )}
              </div>

              {/* Section Inscription et Paiement */}
              <div className="form-section">
                <h4><CreditCard size={20} className="inline mr-2" />Inscription et Paiement</h4>
                <div className="form-row">
                  <div className="form-group">
                    <label>Code Étudiant</label>
                    <input
                      type="text"
                      name="codeEtudiant"
                      placeholder="Code étudiant"
                      value={formModifier.codeEtudiant}
                      onChange={handleChangeModifier}
                    />
                  </div>
                  <div className="form-group">
                    <label>Commercial</label>
                    <select
                      name="commercial"
                      value={formModifier.commercial}
                      onChange={handleChangeModifier}
                    >
                      <option value="">Aucun commercial assigné</option>
                      {listeCommerciaux.map((commercial) => (
                        <option key={commercial._id} value={commercial._id}>
                          {commercial.nomComplet || commercial.nom}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Mode de Paiement *</label>
                    <select
                      name="modePaiement"
                      value={formModifier.modePaiement}
                      onChange={handleChangeModifier}
                      required
                    >
                      <option value="semestriel">Semestriel (2 tranches)</option>
                      <option value="trimestriel">Trimestriel (3 tranches)</option>
                      <option value="mensuel">Mensuel (10 tranches)</option>
                      <option value="annuel">Annuel (paiement complet)</option>
                    </select>
                    <small style={{ color: '#666', fontSize: '12px' }}>
                      Semestriel par défaut. Annuel = paiement immédiat complet.
                    </small>
                  </div>
                  {formModifier.anneeScolaire === '2026/2027' && !formModifier.isPartner ? (
                    <div className="form-group">
                      <label>Type de Remise / Bourse (Grille 2026/2027)</label>
                      <select
                        name="typeRemise"
                        value={formModifier.typeRemise || 'none'}
                        onChange={handleChangeModifier}
                      >
                        {REMISES_LIST.map(r => (
                          <option key={r.id} value={r.id}>{r.label}</option>
                        ))}
                      </select>
                    </div>
                  ) : !formModifier.isPartner ? (
                    <div className="form-group">
                      <label>Prix Total</label>
                      <input
                        type="number"
                        name="prixTotal"
                        placeholder="Prix total (optionnel)"
                        value={formModifier.prixTotal}
                        onChange={handleChangeModifier}
                        min="0"
                        max="99999"
                        step="1"
                      />
                      <small style={{ color: '#666', fontSize: '12px' }}>
                        Champ optionnel - peut être rempli plus tard
                      </small>
                    </div>
                  ) : null}
                </div>

                {formModifier.anneeScolaire === '2026/2027' && !formModifier.isPartner && (
                  <div style={{ padding: '0 15px' }}>
                    {formModifier.typeRemise === 'custom' && (
                      <div className="form-group" style={{ marginBottom: '16px' }}>
                        <label>Montant de la Remise Exceptionnelle (DH)</label>
                        <input
                          type="number"
                          name="remiseMontant"
                          placeholder="Entrez le montant de la remise"
                          value={formModifier.remiseMontant || ''}
                          onChange={handleChangeModifier}
                          min="0"
                          max={formModifier.fraisScolariteBase || 35000}
                        />
                      </div>
                    )}
                    {/* Breakdown récapitulatif */}
                    <div className="pricing-breakdown" style={{
                      backgroundColor: '#f8fafc',
                      border: '1px solid #cbd5e1',
                      borderRadius: '8px',
                      padding: '12px 16px',
                      marginBottom: '16px',
                      fontSize: '14px',
                      color: '#334155'
                    }}>
                      <h5 style={{ margin: '0 0 8px 0', color: '#1e293b', fontWeight: '600' }}>Récapitulatif des tarifs (PV 2026-2027)</h5>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span>Frais de scolarité de base :</span>
                        <span style={{ fontWeight: '500' }}>{(formModifier.fraisScolariteBase || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px' }}>
                        <span>Frais d'inscription :</span>
                        <span style={{ fontWeight: '500' }}>{(formModifier.fraisInscription || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '4px', color: '#dc2626' }}>
                        <span>Remise appliquée ({formModifier.pourcentageBourse || 0}%) :</span>
                        <span style={{ fontWeight: '500' }}>-{(formModifier.remiseMontant || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                      <div style={{ borderTop: '1px solid #cbd5e1', marginTop: '8px', paddingTop: '8px', display: 'flex', justifyContent: 'space-between', fontWeight: 'bold', color: '#0f172a' }}>
                        <span>Total Net à payer :</span>
                        <span>{(formModifier.prixTotal || 0).toLocaleString('fr-FR')} DH</span>
                      </div>
                    </div>
                  </div>
                )}

                <div className="form-row">
                  {!(formModifier.anneeScolaire === '2026/2027' && !formModifier.isPartner) && (
                    <div className="form-group">
                      <label>Pourcentage Bourse (%)</label>
                      <input
                        type="number"
                        name="pourcentageBourse"
                        placeholder="Pourcentage de bourse"
                        value={formModifier.pourcentageBourse}
                        onChange={handleChangeModifier}
                        min="0"
                        max="100"
                      />
                    </div>
                  )}
                  <div className="form-group">
                    <label>Type de Paiement</label>
                    <input
                      type="text"
                      name="typePaiement"
                      placeholder="Type de paiement"
                      value={formModifier.typePaiement}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label>Situation</label>
                    <input
                      type="text"
                      name="situation"
                      placeholder="Situation"
                      value={formModifier.situation}
                      onChange={handleChangeModifier}
                    />
                  </div>
                </div>

                <div className="form-group">
                  <label>Date et Règlement</label>
                  <input
                    type="text"
                    name="dateEtReglement"
                    placeholder="Date et règlement"
                    value={formModifier.dateEtReglement}
                    onChange={handleChangeModifier}
                  />
                </div>
              </div>

              {/* Section Autres informations */}
              <div className="form-section">
                <h4><FileText size={20} className="inline mr-2" />Autres informations</h4>

                <div className="form-group">
                  <label>Image</label>
                  <input
                    type="file"
                    name="image"
                    accept="image/*"
                    onChange={handleImageChangeModifier}
                  />
                </div>

                {/* Section Documents avec commentaires */}
                <div className="documents-section">
                  <h5>Documents avec Commentaires</h5>

                  {/* CIN */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document CIN</label>
                      <input
                        type="file"
                        name="documentCin"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire CIN</label>
                      <input
                        type="text"
                        name="commentaireCin"
                        placeholder="Commentaire pour le CIN"
                        value={commentairesModifier.commentaireCin}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Bac avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Bac</label>
                      <input
                        type="file"
                        name="documentBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac</label>
                      <input
                        type="text"
                        name="commentaireBacCommentaire"
                        placeholder="Commentaire pour le Bac"
                        value={commentairesModifier.commentaireBacCommentaire}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Relevé de Notes Bac */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Relevé de Notes Bac</label>
                      <input
                        type="file"
                        name="documentReleveNoteBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Bac</label>
                      <input
                        type="text"
                        name="commentaireReleveNoteBac"
                        placeholder="Commentaire pour le relevé de notes bac"
                        value={commentairesModifier.commentaireReleveNoteBac}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Bac ou Attestation Bac avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Bac ou Attestation Bac</label>
                      <input
                        type="file"
                        name="documentBacOuAttestationBacCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Bac/Attestation</label>
                      <input
                        type="text"
                        name="commentaireBacOuAttestationBacCommentaire"
                        placeholder="Commentaire pour le bac ou attestation"
                        value={commentairesModifier.commentaireBacOuAttestationBacCommentaire}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Authentification Bac */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Authentification Bac</label>
                      <input
                        type="file"
                        name="documentAuthentificationBac"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentification Bac</label>
                      <input
                        type="text"
                        name="commentaireAuthentificationBac"
                        placeholder="Commentaire pour l'authentification bac"
                        value={commentairesModifier.commentaireAuthentificationBac}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Diplôme avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Diplôme</label>
                      <input
                        type="file"
                        name="documentDiplomeCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Diplôme</label>
                      <input
                        type="text"
                        name="commentaireDiplomeCommentaire"
                        placeholder="Commentaire pour le diplôme"
                        value={commentairesModifier.commentaireDiplomeCommentaire}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Authentication Diplôme */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Authentication Diplôme</label>
                      <input
                        type="file"
                        name="documentAuthenticationDiplome"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Authentication Diplôme</label>
                      <input
                        type="text"
                        name="commentaireAuthenticationDiplome"
                        placeholder="Commentaire pour l'authentication diplôme"
                        value={commentairesModifier.commentaireAuthenticationDiplome}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Attestation de Réussite avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Attestation de Réussite</label>
                      <input
                        type="file"
                        name="documentAttestationReussiteCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Attestation de Réussite</label>
                      <input
                        type="text"
                        name="commentaireAttestationReussiteCommentaire"
                        placeholder="Commentaire pour l'attestation de réussite"
                        value={commentairesModifier.commentaireAttestationReussiteCommentaire}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Relevé de Notes Formation avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Relevé de Notes Formation</label>
                      <input
                        type="file"
                        name="documentReleveNotesFormationCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Relevé Notes Formation</label>
                      <input
                        type="text"
                        name="commentaireReleveNotesFormationCommentaire"
                        placeholder="Commentaire pour le relevé de notes formation"
                        value={commentairesModifier.commentaireReleveNotesFormationCommentaire}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Passeport */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Passeport</label>
                      <input
                        type="file"
                        name="documentPasseport"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Passeport</label>
                      <input
                        type="text"
                        name="commentairePasseport"
                        placeholder="Commentaire pour le passeport"
                        value={commentairesModifier.commentairePasseport}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>

                  {/* Engagement avec commentaire */}
                  <div className="form-row">
                    <div className="form-group">
                      <label>Document Engagement</label>
                      <input
                        type="file"
                        name="documentEngagementCommentaire"
                        accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                        onChange={handleDocumentChangeModifier}
                      />
                    </div>
                    <div className="form-group">
                      <label>Commentaire Engagement</label>
                      <input
                        type="text"
                        name="commentaireEngagementCommentaire"
                        placeholder="Commentaire pour l'engagement"
                        value={commentairesModifier.commentaireEngagementCommentaire}
                        onChange={handleCommentaireChangeModifier}
                      />
                    </div>
                  </div>
                </div>

                <div className="checkbox-grid">
                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="actif"
                        checked={formModifier.actif}
                        onChange={handleChangeModifier}
                      />
                      Étudiant actif
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="paye"
                        checked={formModifier.paye}
                        onChange={handleChangeModifier}
                      />
                      Payé
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="nouvelleInscription"
                        checked={formModifier.nouvelleInscription}
                        onChange={handleChangeModifier}
                      />
                      Nouvelle inscription
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="handicape"
                        checked={formModifier.handicape}
                        onChange={handleChangeModifier}
                      />
                      Handicapé
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="resident"
                        checked={formModifier.resident}
                        onChange={handleChangeModifier}
                      />
                      Résident
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="fonctionnaire"
                        checked={formModifier.fonctionnaire}
                        onChange={handleChangeModifier}
                      />
                      Fonctionnaire
                    </label>
                  </div>

                  <div className="form-group checkbox-group">
                    <label className="checkbox-label">
                      <input
                        type="checkbox"
                        name="mobilite"
                        checked={formModifier.mobilite}
                        onChange={handleChangeModifier}
                      />
                      Mobilité
                    </label>
                  </div>
                </div>
              </div>

              {messageModifier && (
                <div className={`message-ajout ${messageModifier.includes('✅') ? 'success' : 'error'}`}>
                  {messageModifier}
                </div>
              )}

              <div className="modal-actions">
                <button type="button" onClick={closeEditModal} className="btn-annuler">
                  Annuler
                </button>
                <button type="submit" disabled={loadingModifier} className="btn-enregistrer">
                  {loadingModifier ? 'Enregistrement...' : 'Enregistrer'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de visualisation d'étudiant */}
      {showViewModal && etudiantSelectionne && (
        <div className="modal-overlay" onClick={closeViewModal}>
          <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                <h3 style={{ margin: 0 }}>Détails de l'étudiant</h3>
                <button
                  onClick={() => window.location.href = `/etudiant/${etudiantSelectionne._id}`}
                  style={{
                    padding: '6px 12px',
                    backgroundColor: '#6366f1',
                    color: '#ffffff',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '6px'
                  }}
                >
                  👁️ Voir Profil Complet & Historique
                </button>
              </div>
              <button className="btn-fermer-modal" onClick={closeViewModal}>×</button>
            </div>
            {/* Section Validation Pédagogique */}
            <div className="view-section">
              <h4><Shield size={20} className="section-icon" />Validation Pédagogique</h4>
              <div className="info-grid">
                <div className="info-row">
                  <span className="info-label">Statut:</span>
                  <span className="info-value">
                    <span className={`validation-badge-view ${etudiantSelectionne.validationPedagogique?.statut === 'Validé' ? 'valide' :
                      etudiantSelectionne.validationPedagogique?.statut === 'Pas Validé' ? 'pas-valide' :
                        etudiantSelectionne.validationPedagogique?.statut === 'En cours' ? 'en-cours' : 'en-attente'
                      }`}>
                      {etudiantSelectionne.validationPedagogique?.statut || 'En attente'}
                    </span>
                  </span>
                </div>
                {etudiantSelectionne.validationPedagogique?.commentaire && (
                  <div className="info-row">
                    <span className="info-label">Commentaire pédagogique:</span>
                    <span className="info-value">{etudiantSelectionne.validationPedagogique.commentaire}</span>
                  </div>
                )}
                {etudiantSelectionne.validationPedagogique?.dateValidation && (
                  <div className="info-row">
                    <span className="info-label">Date de validation:</span>
                    <span className="info-value">
                      <Calendar size={16} className="info-icon" />
                      {formatDate(etudiantSelectionne.validationPedagogique.dateValidation)}
                    </span>
                  </div>
                )}
              </div>
            </div>
            <div className="view-content">
              {/* Section Informations personnelles */}
              <div className="view-section">
                <h4><User size={20} className="section-icon" />Informations personnelles</h4>
                <div className="student-header">
                  <div className="student-photo">
                    {etudiantSelectionne.image ? (
                      <img
                        src={`     https://vmi1977988.contaboserver.net${etudiantSelectionne.image}`}
                        alt={getNomComplet(etudiantSelectionne)}
                        className="view-photo"
                      />
                    ) : (
                      <div className="view-photo-placeholder">
                        <User size={48} />
                      </div>
                    )}
                  </div>
                  <div className="student-basic-info">
                    <h3 className="student-name">{getNomComplet(etudiantSelectionne)}</h3>
                    <div className="student-status">
                      <span className={`status-badge ${etudiantSelectionne.actif ? 'actif' : 'inactif'}`}>
                        {etudiantSelectionne.actif ? <CheckCircle size={16} /> : <XCircle size={16} />}
                        {etudiantSelectionne.actif ? 'Actif' : 'Inactif'}
                      </span>
                      {etudiantSelectionne.paye && (
                        <span className="status-badge paye">
                          <CheckCircle size={16} />
                          Payé
                        </span>
                      )}
                    </div>
                  </div>
                </div>

                <div className="info-grid">
                  <div className="info-row">
                    <span className="info-label">Genre:</span>
                    <span className="info-value">
                      <User size={16} className="info-icon" />
                      {etudiantSelectionne.genre}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Date de naissance:</span>
                    <span className="info-value">
                      <Cake size={16} className="info-icon" />
                      {formatDate(etudiantSelectionne.dateNaissance)} ({calculerAge(etudiantSelectionne.dateNaissance)} ans)
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Téléphone:</span>
                    <span className="info-value">
                      <Phone size={16} className="info-icon" />
                      {etudiantSelectionne.telephone || 'N/A'}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Email:</span>
                    <span className="info-value">{etudiantSelectionne.email}</span>
                  </div>
                  {etudiantSelectionne.cin && (
                    <div className="info-row">
                      <span className="info-label">CIN:</span>
                      <span>
                        <IdCard size={16} className="inline mr-1" /> {etudiantSelectionne.cin}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.codeMassar && (
                    <div className="info-row">
                      <span className="info-label">Code Massar:</span>
                      <span>
                        <IdCard size={16} className="inline mr-1" /> {etudiantSelectionne.codeMassar}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.passeport && (
                    <div className="info-row">
                      <span className="info-label">Passeport:</span>
                      <span className="info-value">{etudiantSelectionne.passeport}</span>
                    </div>
                  )}
                  {etudiantSelectionne.lieuNaissance && (
                    <div className="info-row">
                      <span className="info-label">Lieu de naissance:</span>
                      <span className="info-value">
                        <MapPin size={16} className="info-icon" />
                        {etudiantSelectionne.lieuNaissance}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.lieuFormation && (
                    <div className="info-row">
                      <span className="info-label">Lieu de formation:</span>
                      <span className="info-value">
                        <MapPin size={16} className="info-icon" />
                        {etudiantSelectionne.lieuFormation}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.pays && (
                    <div className="info-row">
                      <span className="info-label">Pays:</span>
                      <span className="info-value">{etudiantSelectionne.pays}</span>
                    </div>
                  )}
                  {etudiantSelectionne.telephoneResponsable && (
                    <div className="info-row">
                      <span className="info-label">Téléphone du Responsable:</span>
                      <span className="info-value">
                        <Phone size={16} className="info-icon" />
                        {etudiantSelectionne.telephoneResponsable}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.codeBaccalaureat && (
                    <div className="info-row">
                      <span className="info-label">Code du Baccalauréat:</span>
                      <span className="info-value">{etudiantSelectionne.codeBaccalaureat}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Formation */}
              <div className="view-section">
                <h4><GraduationCap size={20} className="section-icon" />Formation</h4>
                <div className="info-grid">
                  {etudiantSelectionne.anneeScolaire && (
                    <div className="info-row">
                      <span className="info-label">Année Scolaire:</span>
                      <span className="info-value">
                        <Calendar size={16} className="info-icon" />
                        {etudiantSelectionne.anneeScolaire}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.niveau && (
                    <div className="info-row">
                      <span className="info-label">Niveau:</span>
                      <span className="info-value">{etudiantSelectionne.niveau}</span>
                    </div>
                  )}
                  {etudiantSelectionne.niveauFormation && (
                    <div className="info-row">
                      <span className="info-label">Niveau de formation:</span>
                      <span className="info-value">{etudiantSelectionne.niveauFormation}</span>
                    </div>
                  )}
                  {etudiantSelectionne.filiere && (
                    <div className="info-row">
                      <span className="info-label">Filière:</span>
                      <span className="info-value">{etudiantSelectionne.filiere}</span>
                    </div>
                  )}
                  {etudiantSelectionne.cycle && (
                    <div className="info-row">
                      <span className="info-label">Cycle:</span>
                      <span className="info-value">{etudiantSelectionne.cycle}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteIngenieur && (
                    <div className="info-row">
                      <span className="info-label">Spécialité d'Ingénieur:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteIngenieur}</span>
                    </div>
                  )}
                  {etudiantSelectionne.optionIngenieur && (
                    <div className="info-row">
                      <span className="info-label">Option d'Ingénieur:</span>
                      <span className="info-value">{etudiantSelectionne.optionIngenieur}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteLicencePro && (
                    <div className="info-row">
                      <span className="info-label">Spécialité Licence Pro:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteLicencePro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.optionLicencePro && (
                    <div className="info-row">
                      <span className="info-label">Option Licence Pro:</span>
                      <span className="info-value">{etudiantSelectionne.optionLicencePro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteMasterPro && (
                    <div className="info-row">
                      <span className="info-label">Spécialité Master Pro:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteMasterPro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.optionMasterPro && (
                    <div className="info-row">
                      <span className="info-label">Option Master Pro:</span>
                      <span className="info-value">{etudiantSelectionne.optionMasterPro}</span>
                    </div>
                  )}
                  {etudiantSelectionne.option && (
                    <div className="info-row">
                      <span className="info-label">Option:</span>
                      <span className="info-value">{etudiantSelectionne.option}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialite && (
                    <div className="info-row">
                      <span className="info-label">Spécialité:</span>
                      <span className="info-value">{etudiantSelectionne.specialite}</span>
                    </div>
                  )}
                  {etudiantSelectionne.typeDiplome && (
                    <div className="info-row">
                      <span className="info-label">Type de diplôme:</span>
                      <span className="info-value">{etudiantSelectionne.typeDiplome}</span>
                    </div>
                  )}
                  {etudiantSelectionne.cours && etudiantSelectionne.cours.length > 0 && (
                    <div className="info-row full-width">
                      <span className="info-label">Classe:</span>
                      <div className="cours-tags">
                        {etudiantSelectionne.cours.map((cours, index) => (
                          <span key={index} className="cours-tag">
                            <BookOpen size={14} className="info-icon" />
                            {cours}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Diplôme et Parcours */}
              <div className="view-section">
                <h4><Award size={20} className="section-icon" />Diplôme et Parcours antérieur</h4>
                <div className="info-grid">
                  {etudiantSelectionne.diplomeAcces && (
                    <div className="info-row">
                      <span className="info-label">Diplôme d'accès:</span>
                      <span className="info-value">{etudiantSelectionne.diplomeAcces}</span>
                    </div>
                  )}
                  {etudiantSelectionne.specialiteDiplomeAcces && (
                    <div className="info-row">
                      <span className="info-label">Spécialité du diplôme d'accès:</span>
                      <span className="info-value">{etudiantSelectionne.specialiteDiplomeAcces}</span>
                    </div>
                  )}
                  {etudiantSelectionne.mention && (
                    <div className="info-row">
                      <span className="info-label">Mention:</span>
                      <span className="info-value">{etudiantSelectionne.mention}</span>
                    </div>
                  )}
                  {etudiantSelectionne.lieuObtentionDiplome && (
                    <div className="info-row">
                      <span className="info-label">Lieu d'obtention du diplôme:</span>
                      <span className="info-value">
                        <MapPin size={16} className="info-icon" />
                        {etudiantSelectionne.lieuObtentionDiplome}
                      </span>
                    </div>
                  )}
                  {etudiantSelectionne.serieBaccalaureat && (
                    <div className="info-row">
                      <span className="info-label">Série du baccalauréat:</span>
                      <span className="info-value">{etudiantSelectionne.serieBaccalaureat}</span>
                    </div>
                  )}
                  {etudiantSelectionne.anneeBaccalaureat && (
                    <div className="info-row">
                      <span className="info-label">Année du baccalauréat:</span>
                      <span className="info-value">{etudiantSelectionne.anneeBaccalaureat}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Inscription et Paiement */}
              <div className="view-section">
                <h4><CreditCard size={20} className="section-icon" />Inscription et Paiement</h4>
                <div className="info-grid">
                  {etudiantSelectionne.codeEtudiant && (
                    <div className="info-row">
                      <span className="info-label">Code étudiant:</span>
                      <span className="info-value">{etudiantSelectionne.codeEtudiant}</span>
                    </div>
                  )}
                  <div className="info-row">
                    <span className="info-label">Commercial:</span>
                    <span className="info-value">
                      <UserCheck size={16} className="info-icon" />
                      {getNomCommercial(etudiantSelectionne.commercial)}
                    </span>
                  </div>
                  <div className="info-row">
                    <span className="info-label">Type d'étudiant:</span>
                    <span className="info-value">
                      <span className={`type-badge ${etudiantSelectionne.isPartner ? 'partner' : 'normal'}`}>
                        {etudiantSelectionne.isPartner ? '🤝 Partner' : '👤 Normal'}
                      </span>
                    </span>
                  </div>
                  {etudiantSelectionne.isPartner && etudiantSelectionne.nomPartner && (
                    <div className="info-row">
                      <span className="info-label">Nom du Partenaire:</span>
                      <span className="info-value">{etudiantSelectionne.nomPartner}</span>
                    </div>
                  )}
                  {etudiantSelectionne.isPartner && etudiantSelectionne.prixTotalPartner && (
                    <div className="info-row">
                      <span className="info-label">Prix Partner:</span>
                      <span className="info-value">{etudiantSelectionne.prixTotalPartner} DH</span>
                    </div>
                  )}
                  {etudiantSelectionne.sourceInscription && (
                    <div className="info-row">
                      <span className="info-label">Source d'inscription:</span>
                      <span className="info-value">{etudiantSelectionne.sourceInscription}</span>
                    </div>
                  )}
                  {etudiantSelectionne.modePaiement && (
                    <div className="info-row">
                      <span className="info-label">Mode de paiement:</span>
                      <span className="info-value">
                        <CreditCard size={16} className="info-icon" />
                        {etudiantSelectionne.modePaiement}
                      </span>
                    </div>
                  )}
                  <div className="info-row">
                    <span className="info-label">Numéro de Reçu:</span>
                    <span className="info-value" style={{ fontWeight: 'bold', color: '#2563eb' }}>
                      {etudiantSelectionne.numRecu || 'N/A'}
                    </span>
                  </div>
                  {etudiantSelectionne.prixTotal && (
                    <div className="info-row">
                      <span className="info-label">Prix total:</span>
                      <span className="info-value">{etudiantSelectionne.prixTotal} DH</span>
                    </div>
                  )}
                  {etudiantSelectionne.pourcentageBourse && (
                    <div className="info-row">
                      <span className="info-label">Pourcentage bourse:</span>
                      <span className="info-value">{etudiantSelectionne.pourcentageBourse}%</span>
                    </div>
                  )}
                  {etudiantSelectionne.typePaiement && (
                    <div className="info-row">
                      <span className="info-label">Type de paiement:</span>
                      <span className="info-value">{etudiantSelectionne.typePaiement}</span>
                    </div>
                  )}
                  {etudiantSelectionne.situation && (
                    <div className="info-row">
                      <span className="info-label">Situation:</span>
                      <span className="info-value">{etudiantSelectionne.situation}</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Section Documents */}
              {etudiantSelectionne.documents && Object.keys(etudiantSelectionne.documents).length > 0 && (
                <div className="view-section">
                  <h4><FileText size={20} className="section-icon" />Documents et Pièces Justificatives</h4>
                  <div className="documents-professional-grid">
                    {Object.entries(etudiantSelectionne.documents).map(([key, doc]) => {
                      if (doc && doc.fichier) {
                        // Convertir le nom du champ en libellé lisible
                        const getDocumentLabel = (key) => {
                          const labels = {
                            'cin': 'CIN',
                            'bacCommentaire': 'Baccalauréat',
                            'releveNoteBac': 'Relevé de Notes Bac',
                            'diplomeCommentaire': 'Diplôme',
                            'attestationReussiteCommentaire': 'Attestation de Réussite',
                            'releveNotesFormationCommentaire': 'Relevé de Notes Formation',
                            'passeport': 'Passeport',
                            'bacOuAttestationBacCommentaire': 'Bac ou Attestation Bac',
                            'authentificationBac': 'Authentification Bac',
                            'authenticationDiplome': 'Authentication Diplôme',
                            'engagementCommentaire': 'Engagement'
                          };
                          return labels[key] || key.replace(/([A-Z])/g, ' $1').trim();
                        };

                        return (
                          <div key={key} className="document-item">
                            <div className="document-info">
                              <FileText size={16} className="info-icon" />
                              <div className="document-details">
                                <span className="document-name">{getDocumentLabel(key)}</span>
                                {doc.commentaire && (
                                  <small className="document-comment">� {doc.commentaire}</small>
                                )}
                                {doc.dateUpload && (
                                  <small className="document-date">
                                    Ajouté le {formatDate(doc.dateUpload)}
                                  </small>
                                )}
                              </div>
                            </div>
                            <a
                              href={`     https://vmi1977988.contaboserver.net${doc.fichier}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="btn-voir-document"
                            >
                              Voir
                            </a>
                          </div>
                        );
                      }
                      return null;
                    })}
                  </div>

                  {Object.keys(etudiantSelectionne.documents).filter(key =>
                    etudiantSelectionne.documents[key] && etudiantSelectionne.documents[key].fichier
                  ).length === 0 && (
                      <div className="no-documents-message">
                        <FileText size={48} className="no-docs-icon" />
                        <h4>Aucun document disponible</h4>
                        <p>Aucune pièce justificative n'a été téléchargée pour cet étudiant.</p>
                      </div>
                    )}
                </div>
              )}

              {/* Section Statuts spéciaux */}
              <div className="view-section">
                <h4><Shield size={20} className="section-icon" />Statuts spéciaux</h4>
                <div className="statuts-grid">
                  {etudiantSelectionne.handicape && (
                    <span className="statut-special handicape">♿ Handicapé</span>
                  )}
                  {etudiantSelectionne.resident && (
                    <span className="statut-special resident">🏠 Résident</span>
                  )}
                  {etudiantSelectionne.fonctionnaire && (
                    <span className="statut-special fonctionnaire">👨‍💼 Fonctionnaire</span>
                  )}
                  {etudiantSelectionne.mobilite && (
                    <span className="statut-special mobilite">🌍 Mobilité</span>
                  )}
                </div>
                {!etudiantSelectionne.handicape && !etudiantSelectionne.resident &&
                  !etudiantSelectionne.fonctionnaire && !etudiantSelectionne.mobilite && (
                    <p className="no-statut">Aucun statut spécial</p>
                  )}
              </div>

              {/* Section Dates importantes */}
              {(etudiantSelectionne.dateInscription || etudiantSelectionne.dateEtReglement ||
                etudiantSelectionne.premiereAnneeInscription || etudiantSelectionne.lastSeen ||
                etudiantSelectionne.createdAt || etudiantSelectionne.updatedAt) && (
                  <div className="view-section">
                    <h4><Calendar size={20} className="section-icon" />Dates importantes</h4>
                    <div className="info-grid">
                      {etudiantSelectionne.dateInscription && (
                        <div className="info-row">
                          <span className="info-label">Date d'inscription:</span>
                          <span className="info-value">
                            <Calendar size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.dateInscription)}
                          </span>
                        </div>
                      )}
                      {etudiantSelectionne.premiereAnneeInscription && (
                        <div className="info-row">
                          <span className="info-label">Première année d'inscription:</span>
                          <span className="info-value">{etudiantSelectionne.premiereAnneeInscription}</span>
                        </div>
                      )}
                      {etudiantSelectionne.dateEtReglement && (
                        <div className="info-row">
                          <span className="info-label">Date et règlement:</span>
                          <span className="info-value">{etudiantSelectionne.dateEtReglement}</span>
                        </div>
                      )}
                      {etudiantSelectionne.lastSeen && (
                        <div className="info-row">
                          <span className="info-label">Dernière connexion:</span>
                          <span className="info-value">

                            <Clock size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.lastSeen)}
                          </span>
                        </div>
                      )}
                      {etudiantSelectionne.createdAt && (
                        <div className="info-row">
                          <span className="info-label">Créé le:</span>
                          <span className="info-value">
                            <Plus size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.createdAt)}
                          </span>
                        </div>
                      )}
                      {etudiantSelectionne.updatedAt && (
                        <div className="info-row">
                          <span className="info-label">Dernière modification:</span>
                          <span className="info-value">
                            <Edit size={16} className="info-icon" />
                            {formatDate(etudiantSelectionne.updatedAt)}
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                )}
            </div>

            <div className="modal-actions view-actions">
              <button onClick={() => handleEdit(etudiantSelectionne)} className="btn-modifier">
                <Edit size={16} className="info-icon" />
                Modifier
              </button>
              <button onClick={closeViewModal} className="btn-fermer">
                Fermer
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal d'export Excel */}
      {showExportModal && (
        <div className="modal-overlay" onClick={() => setShowExportModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Exporter vers Excel</h3>
              <button className="btn-fermer-modal" onClick={() => setShowExportModal(false)}>×</button>
            </div>

            <div className="export-content">
              <p>Sélectionnez l'année scolaire pour l'export des étudiants :</p>

              <div className="form-group">
                <label>Année Scolaire *</label>
                <select
                  value={exportAnneeScolaire}
                  onChange={(e) => setExportAnneeScolaire(e.target.value)}
                  className="select-filtre"
                  required
                >
                  <option value="">Sélectionner une option d'export...</option>
                  <option value="FILTRES">📊 Les {etudiantsFiltres.length} étudiants actuellement filtrés / affichés</option>
                  <option value="TOUS">🌐 Tous les étudiants de la base ({etudiants.length})</option>
                  {annesScolairesUniques.map(annee => (
                    <option key={annee} value={annee}>📅 Année Scolaire {annee}</option>
                  ))}
                </select>
              </div>

              {exportAnneeScolaire && (
                <div className="export-preview">
                  <p>
                    <strong>Aperçu :</strong>{' '}
                    {exportAnneeScolaire === 'FILTRES'
                      ? `${etudiantsFiltres.length} étudiant(s) actuellement filtrés`
                      : exportAnneeScolaire === 'TOUS'
                        ? `${etudiants.length} étudiant(s) au total`
                        : `${etudiants.filter(e => e.anneeScolaire === exportAnneeScolaire).length} étudiant(s) pour l'année ${exportAnneeScolaire}`}
                  </p>
                </div>
              )}
            </div>

            <div className="modal-actions">
              <button
                type="button"
                onClick={() => setShowExportModal(false)}
                className="btn-annuler"
                disabled={loadingExport}
              >
                Annuler
              </button>
              <button
                type="button"
                onClick={exportToExcel}
                className="btn-export"
                disabled={loadingExport || !exportAnneeScolaire}
              >
                {loadingExport ? '📥 Export en cours...' : '📊 Exporter'}
              </button>
            </div>
          </div>
        </div>
      )}{/* Modal de désistement */}
      {showDesistementModal && etudiantDesistement && (
        <DesistementModalAdmin
          etudiant={etudiantDesistement}
          onClose={closeDesistementModal}
          onSuccess={handleDesistementSuccess}
        />
      )}
      {showModalInactifs && (
        <ModalEtudiantsInactifs
          onClose={closeModalInactifs}
          onRestaure={handleAfterRestaure}
        />
      )}

    </div>
  );
};

export default ListeEtudiants;